import { createCompanyOptions } from "./helper.js";

import {
  createRowsToRender,
  renderTableArray,
  newRowId,
  lockEventListenersTable,
  unlockEventListenersTable,
  createAddedRow,
  clearTable,
} from "./helperTable.js";
import { headerCrop, supplyKeys } from "./model/modelCrops.js";
import {
  headerCompany,
  sectors,
  companyRowsDefault,
} from "./model/modelCompany.js";
import {
  menuTag,
  sectorRowsValid,
  sectorRows,
  companyRowsValid,
  companyRows,
  cropRowsValid,
  cropRows,
  productRowsValid,
  productRows,
  planRowsValid,
  planRows,
  fertiProductRowsValid,
  fertiProductRows,
} from "./controller.js";
import {
  rowsNum,
  productsForPhase,
  lineSpeed,
  pipeSpeed,
  rowsBasicNum,
} from "./config.js";
import {
  capitalizeFirstLetter,
  renderCheckExitBtn,
  updateNewPlanUI,
  renderCheckContinueBtn,
  findSelectedSector,
  findSelectedCrop,
  findSelectedProduct,
  renderPlanRecap,
} from "./helperPlan.js";
import { cropService } from "./services/crops";
import { planService } from "./services/plans";

//Elements
const updateSectorWindow = document.querySelector(".update-sector-window");
const addSectorBtnModal = document.querySelector(".sector_modal");
const sectorForm = document.querySelector(".upload-sector");

//Empty data window
const emptyDataAlertWindow = document.querySelector(".empty-data-window");
//const emptyDataModalBtn = document.querySelector(".empty-data_modal");
//const emptyDataBtn = document.querySelector(".empty-data__btn");
const emptyDataHeading = document.querySelector(".empty-data__heading");

//Confirm action window
const confirmActionWindow = document.querySelector(".confirm-action-window");
const confirmActionModalBtn = document.querySelector(
  ".alert-confirm-action-modal",
);
const confirmActionBtn = document.querySelector(".confirm-btn");
const confirmActionNotBtn = document.querySelector(".not-confirm-btn");
const confirmActionHeading = document.querySelector(".confirm-action-heading");

//Wrong supplyInput window
const wrongSupplyInputWindow = document.querySelector(
  ".wrong-supply-input-window",
);
const supplyInputModalBtn = document.querySelector(".supply-input_modal");
const okSupplyInputBtn = document.querySelector(".ok-supply-input__btn");

//Variables
const btnLogout = document.querySelector(".logout__btn");
let newPlan = {};
//let fertiPlanData = [];
newPlan.fertiPlanData = [];
//let fertiPlanTotData = [];
newPlan.fertiPlanTotData = [];
const fertiPlans = [];
let missingPriceListStringBase = "";

let menuTagCurrBtn;
let dataBtn,
  supplyProgramBtn,
  ufPlanBtn,
  fertiPlanBtn,
  renderPlanBtn,
  newPlanTableWindow,
  newPlanNav,
  newPlanWindow,
  newPlanMenuBtns,
  fertiTableWindow,
  originalCompanyRows,
  originalPlanRows,
  originalSectorRows,
  originalCropRows,
  originalProductRows,
  originalFertiProductRows,
  account;

// Initialize originalCropRows
const initOriginalCropRows = async () => {
  const result = await cropService.listCrops();
  if (!result.success) {
    console.error("Failed to load crops:", result.error);
    return cropRowsDefault;
  }

  // Transform the data to match the old structure
  return result.data.map((crop) => ({
    cropId: crop.id,
    crop: crop.crop_name || crop.crop,
    countN: crop.countN,
    countP2O5: crop.countP2O5,
    countK2O: crop.countK2O,
    countCaO: crop.countCaO,
    countMgO: crop.countMgO,
    countSO3: crop.countSO3,
  }));
};

// Initialize originalCropRows when the module loads
initOriginalCropRows().then((crops) => {
  originalCropRows = crops;
  console.log("Crops initialized:", originalCropRows);
});

export const controlNewPlanProject = async function (
  newPlanWindowArg,
  currBtn,
  currAccount,
) {
  menuTagCurrBtn = currBtn;
  newPlanWindow = newPlanWindowArg;
  account = currAccount;

  //Update all OriginalXRows (***add declaration variable outside the function)
  originalCompanyRows = await companyRowsValid();
  originalSectorRows = await sectorRowsValid();
  originalPlanRows = planRowsValid(planRows);

  originalCropRows = await cropRowsValid();
  originalProductRows = await productRowsValid();
  originalFertiProductRows = await fertiProductRowsValid();

  renderNewPlanWindow(newPlanWindow);
  btnLogout.classList.add("no-pointer-events");

  //New Plan elements
  dataBtn = document.querySelector(".new-plan-data_btn");
  supplyProgramBtn = document.querySelector(".supply-program_btn");
  ufPlanBtn = document.querySelector(".uf-program_btn");
  fertiPlanBtn = document.querySelector(".ferti-program_btn");
  renderPlanBtn = document.querySelector(".render-plan_btn");
  newPlanTableWindow = document.querySelector(".new-plan_table_window");
  newPlanNav = document.querySelector(".new-plan_nav");

  newPlanMenuBtns = [
    dataBtn,
    supplyProgramBtn,
    ufPlanBtn,
    fertiPlanBtn,
    renderPlanBtn,
  ];

  //Display alert windowAdd commentMore actions
  const msg =
    "Prima di inserire un nuovo piano, verificare che tutti i dati necessari siano presenti in GESTIONE ANAGRAFICHE e CATALOGO PRODOTTI (inclusi i LISTINI PREZZI per l'Azienda di riferimento). Se i Listini Prezzi non sono inseriti, i costi totali del piano non possono essere calcolati.";
  renderEmptyDataAlertWindow(msg, newPlanWindow, "newPlan");

  //Init newPlan
  newPlan = {};
  newPlan.fertiPlanData = [];
  newPlan.fertiPlanTotData = [];

  //DATA SECTION
  await controlDataSection();
};

const renderNewPlanWindow = function (newPlanWindow) {
  const newPlanMarkup = `
  <nav class="new-plan_nav">
    <button class="btn new-plan-menu__btn new-plan-data_btn new-plan__btn--active">
      <span>1 - Dati Nuovo Piano</span>
    </button>
    <button class="btn new-plan-menu__btn supply-program_btn">
      <span>2 - Programmazione Apporti Totali</span>
    </button>
    <button class="btn new-plan-menu__btn uf-program_btn">
      <span>3 - Programmazione Concimazione di Fondo</span>
    </button>
    <button class="btn new-plan-menu__btn ferti-program_btn">
      <span>4 - Programmazione Fertirrigazione</span>
    </button>
    <button class="btn new-plan-menu__btn render-plan_btn">
      <span>5 - Riepilogo</span>
    </button>
  </nav>

  <div class="new-plan_table_window"></div>`;

  newPlanWindow.insertAdjacentHTML("afterbegin", newPlanMarkup);
};

//--------CONTROL DATA SECTION------
//----------------------------------
//----------------------------------
const controlDataSection = async function () {
  updateNewPlanUI(newPlanMenuBtns, dataBtn, newPlanTableWindow, [newPlanNav]);

  unlockNav(dataBtn);

  //Render Form Data
  const selectCompany = await renderFormData(newPlanTableWindow);

  //Form Elements
  const planNameField = document.querySelector(".plan-name");
  const planDateField = document.querySelector(".date_input");
  const selectCompanyForm = document.querySelector(".select-company");
  const selectSectorForm = document.querySelector(".select-sector");

  //Check if newPlan is already filled
  console.log(newPlan);
  if (newPlan.companyId) {
    console.log("newPlan.companyId exists");
    //Fill with newPlan data
    planNameField.value = newPlan.planName;
    planDateField.value = newPlan.date;

    console.log("CompanyId: ", newPlan.companyId);
    let companyStringOption;
    console.log("Original CompanyRows:", originalCompanyRows);
    originalCompanyRows.forEach((company) => {
      if (company.companyId === newPlan.companyId) {
        console.log("Check companyId:  ok");
        companyStringOption = `${company.company}`;
        console.log(companyStringOption);
      }
    });
    selectCompany.value = companyStringOption;
  }

  console.log("select company", selectCompany, selectCompany.value);

  //Get selected company
  checkSelectedCompany(selectCompany, selectCompanyForm, selectSectorForm);

  //Form Elements
  const form = document.querySelector(".upload-new-plan");
  const formBtn = document.querySelector(".upload-company-date__btn");

  //Read input form values
  formBtn.addEventListener("click", function (e) {
    e.preventDefault();
    const dataArr = [...new FormData(form)];
    const inputValues = Object.fromEntries(dataArr);
    console.log(inputValues);

    checkDataFormInputValues(inputValues);
  });

  renderCheckExitBtn(
    newPlanNav,
    newPlanTableWindow,
    newPlanWindow,
    menuTagCurrBtn,
    account,
  );
};

const renderFormData = async function (dataSection) {
  let today = new Date().toISOString().split("T")[0];

  const headingNewPlanMarkup = `
  <br>
  <div class="new-plan-div">
  <img src="/icons/menu-newPlan1.jpg" alt="company" class="menu__btn-icon">
  <h3 class="new-plan-header new-plan-data-header"> DATI NUOVO PIANO</h3>
  </div>
  <form class="upload upload-new-plan" id="upload-form">
    <div class="upload__column-new-plan">
        <label class="upload-plan-name__label">Nome piano</label>
        <input  required name="planName" type="text" class="plan-name"/>
        <label class="upload-date__label">Data</label>
        <input  required name="date" type="date" class= "date_input" />
        </div> 
        <div class="select-company">
        </div>
        <div class="select-sector">
        </div>
    </form>
    <button class="btn upload__btn upload-company-date__btn">
    <span>Continua</span>
    </button>
    `;

  dataSection.insertAdjacentHTML("beforeend", headingNewPlanMarkup);

  //Set default today date
  const inputDate = document.querySelector(".date_input");
  inputDate.value = today;

  //Form Elements
  const selectCompanyForm = document.querySelector(".select-company");
  const selectSectorForm = document.querySelector(".select-sector");

  const selectCompany = await renderSelectCompany(selectCompanyForm);
  return selectCompany;
};

const checkDataFormInputValues = function (inputValues) {
  //NOT VALID INPUT VALUES
  if (
    (inputValues.planName === "") |
    (inputValues.date === "") |
    !newPlan.companyId |
    !newPlan.sectorId
  ) {
    renderEmptyDataAlertWindow(
      "Dati incompleti: compilare tutti i campi prima di procedere.",
      newPlanTableWindow,
      "newPlan",
    );
  }
  //VALID INPUT VALUES
  if (
    inputValues.planName !== "" &&
    inputValues.date !== "" &&
    newPlan.companyId &&
    newPlan.sectorId
  ) {
    //Create newPlan object data properties
    //newPlan.planId = newRowId(originalPlanRows, "planId");
    newPlan.planName = inputValues.planName;
    newPlan.date = inputValues.date;

    createSectorData();
    controlSupplyProgram();
  }
};

export const renderSelectCompany = async function (selectCompanyForm) {
  selectCompanyForm.innerHTML = "";

  const markup = `
  <br>
  <div class="new-plan-div">
  <img src="/icons/menu-company.jpg" alt="company" class="menu__btn-icon">
  <h3 class="new-plan-header new-plan-header-company"> SELEZIONARE AZIENDA</h3></div>
  <select id="company-select" >
    <option value=""> --Seleziona azienda--</option>
  </select>
  <br>`;

  selectCompanyForm.insertAdjacentHTML("beforeend", markup);

  const selectCompany = document.getElementById("company-select");
  const originalCompanyRows = await companyRowsValid();
  createCompanyOptions(originalCompanyRows, selectCompany);

  return selectCompany;
};

const checkSelectedCompany = function (
  selectCompany,
  selectCompanyForm,
  selectSectorForm,
) {
  checkCompanyOption(selectCompany, selectSectorForm, selectCompanyForm);

  selectCompany.addEventListener("change", (e) => {
    e.preventDefault();
    checkCompanyOption(selectCompany, selectSectorForm, selectCompanyForm);
  });
  console.log(newPlan);
};

const checkCompanyOption = function (
  selectCompany,
  selectSectorForm,
  selectCompanyForm,
) {
  //CHECK SELECT COMPANY
  //newPlan.company exists
  if (newPlan.companyId) {
    if (!selectCompany.value) {
      const table = document.querySelector(".myTable");
      removeTable(table);
      selectSectorForm.innerHTML = "";
      newPlan.companyId = "";
    }
    if (selectCompany.value) {
      updateCompanyExist(
        selectCompany,
        selectCompanyForm,
        selectSectorForm,
      ).catch((err) => {
        console.error("Error updating company:", err);
      });
    }
  }

  //newPlan.company doesn't exist
  if (!newPlan.companyId) {
    if (!selectCompany.value) {
      const table = document.querySelector(".myTable");
      removeTable(table);
      selectSectorForm.innerHTML = "";
    }

    if (selectCompany.value) {
      updateCompanyExist(
        selectCompany,
        selectCompanyForm,
        selectSectorForm,
      ).catch((err) => {
        console.error("Error updating company:", err);
      });
    }
  }
  console.log(newPlan);
};

const updateCompanyExist = async function (
  selectCompany,
  selectCompanyForm,
  selectSectorForm,
) {
  console.log(selectCompany);
  const selectedCompanyId =
    selectCompany.options[selectCompany.selectedIndex].dataset.companyId;

  // Filter to get only the selected company
  const selectedCompanyRowArray = originalCompanyRows.filter(
    (r) => r.companyId === selectedCompanyId,
  );

  console.log("Selected company:", selectedCompanyId, selectedCompanyRowArray);

  await renderSelectedCompanyTable(selectedCompanyRowArray, selectCompanyForm);

  //Update newPlan with selected company
  newPlan.companyId = selectedCompanyId;
  console.log(newPlan);

  const selectSector = renderSelectSector(
    selectedCompanyRowArray,
    selectSectorForm,
  );

  //Check if newPlan has basePriceList
  if (newPlan.ufBaseSupply) {
    checkValidPriceListBase(newPlan.ufBaseSupply);
  }

  //Check if newPlan hase fertiPriceList
  if (newPlan.fertiPlanData) {
    checkValidPriceListFerti(newPlan);
  }

  //Check if newPlan.sectorId is already filled
  console.log(newPlan);
  console.log("originalSectorRows: ", originalSectorRows);
  let sectorCompanyId;
  originalSectorRows.forEach((sector) => {
    if (sector.sectorId === newPlan.sectorId) {
      sectorCompanyId = sector.companyId;
    }
  });
  console.log(sectorCompanyId);

  if (newPlan.companyId && sectorCompanyId === newPlan.companyId) {
    console.log("planId exists");
    let sectorStringOption;
    originalSectorRows.forEach((sector) => {
      if (sector.sectorId === newPlan.sectorId) {
        sectorStringOption = `${sector.name}`;
        console.log(sectorStringOption);
      }
    });
    selectSector.value = sectorStringOption;
  }
  console.log(selectSector.value);

  //Get selected Sector
  getSelectedSector(selectSector, selectSectorForm, selectedCompanyRowArray);
};

const checkValidPriceListFerti = function (newPlan) {
  console.log("check ferti price list");
  newPlan.fertiPlanData.forEach((phaseData) => {
    originalFertiProductRows.forEach((fertiProduct) => {
      if (fertiProduct.productId === phaseData.productId) {
        let validPriceList = "";
        fertiProduct.countEurokg.forEach((priceList) => {
          console.log(fertiProduct.countEurokg, newPlan.companyId);
          if (priceList[0] === newPlan.companyId) validPriceList = priceList;
        });
        console.log(validPriceList);
        if (validPriceList !== "") {
          phaseData.validPrice = validPriceList[1];
        }
        if (validPriceList === "") {
          phaseData.validPrice = 0;
          phaseData.costHa = 0;
          phaseData.costSector = 0;
        }
      }
    });
  });
  console.log(newPlan);

  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    const minPhaseRow =
      phaseTotData.phase * productsForPhase - (productsForPhase - 1);
    const maxPhaseRow = phaseTotData.phase * productsForPhase;
    calcTotCost(minPhaseRow, maxPhaseRow, phaseTotData.phase);
  });
};

export const renderSelectedCompanyTable = async function (
  selectedCompanyRowArray,
  selectCompanyForm,
) {
  const header = [...headerCompany, "Settori"];
  const rowToRender = await createRowsToRender(
    selectedCompanyRowArray,
    "company",
  );
  if (!rowToRender) {
    console.error("Failed to create rows to render");
    return;
  }
  const finalRows = rowToRender.map((r) => r.slice(0, -1));

  const table = document.querySelector(".myTable");
  removeTable(table);

  renderTableArray(header, finalRows, selectCompanyForm, "", "new-plan-thead");
};

const renderSelectSector = function (
  selectedCompanyRowArray,
  selectSectorForm,
) {
  selectSectorForm.innerHTML = "";

  const markup = `<br>
  <div class="new-plan-div">
  <img src="/icons/menu-sector.jpg" alt="company" class="menu__btn-icon">
  <h3 class="new-plan-header new-plan-sector-header"> SELEZIONARE SETTORE</h3>
  </div>
  <select id="sector-select" >
  <option value=""> --Selezionare settore--</option>
      </select>
      `;
  selectSectorForm.insertAdjacentHTML("beforeend", markup);

  //Create sector options
  console.log("Selected company array:", selectedCompanyRowArray);
  const [currCompany] = selectedCompanyRowArray;
  if (!currCompany) {
    console.error("No company selected");
    return;
  }

  // Filter sectors for the selected company
  const currSectors = originalSectorRows.filter(
    (sector) => sector.companyId === currCompany.companyId,
  );
  console.log("Available sectors for company:", currSectors);

  //Render sector options
  const selectSector = document.getElementById("sector-select");

  if (currSectors.length === 0) {
    console.log("No sectors found for this company");
    const element = document.createElement("option");
    element.textContent = "Nessun settore disponibile";
    element.value = "";
    selectSector.appendChild(element);
  } else {
    console.log(currSectors);
    //Create crop options with id and text
    const options = currSectors.map((r) => ({
      id: r.id || r.sectorId, // Handle both new Supabase and old format
      text: `${r.name || r.sector}`, // Handle both formats
    }));
    console.log(options);
    options.forEach((option) => {
      let element = document.createElement("option");
      element.textContent = option.text;
      element.value = option.text;
      element.dataset.sectorId = option.id;
      selectSector.appendChild(element);
    });
  }

  return selectSector;
};

const getSelectedSector = function (
  selectSector,
  selectSectorForm,
  selectedCompanyRowArray,
) {
  checkSectorOption(selectSector);
  //Listen select sector
  selectSector.addEventListener("change", (e) => {
    e.preventDefault();
    checkSectorOption(selectSector);
  });
  console.log(newPlan);
};

const checkSectorOption = function (selectSector) {
  //SELECTION: OLD SECTOR
  if (selectSector.value !== "--Selezionare settore--") {
    //lockEventListenersTable([newPlanNav, menuTag]);

    const selectedSectorId =
      selectSector.options[selectSector.selectedIndex].dataset.sectorId;

    //Update newPlan with selected sector
    newPlan.sectorId = selectedSectorId;
    console.log("Selected sector:", selectedSectorId, newPlan);
  }

  //SELECTION: NOT SELECTED
  if (!selectSector.value) {
    console.log("no sector selected");
  }
};

const checkNewSectorModalBtn = function (
  addSectorBtnModal,
  updateSectorWindow,
  selectSectorForm,
  selectedCompanyRowArray,
) {
  addSectorBtnModal.addEventListener("click", (e) => {
    e.preventDefault();
    updateSectorWindow.classList.add("hidden");

    unlockEventListenersTable([newPlanNav, newPlanTableWindow, menuTag]);

    const selectSector = renderSelectSector(
      selectedCompanyRowArray,
      selectSectorForm,
    );

    //Get selected Sector
    getSelectedSector(selectSector, selectSectorForm, selectedCompanyRowArray);
  });
};

const checkEmptyDataBtn = function (btn, emptyDataAlertWindow, unlockEl) {
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    emptyDataAlertWindow.classList.add("hidden");

    unlockEventListenersTable(unlockEl);
  });
};

const removeTable = function (table) {
  if (table) {
    console.log("table exists");
    table.remove();
  }
};

//--------CONTROL SUPPLY PROGRAM SECTION------
//----------------------------------
//----------------------------------
const controlSupplyProgram = function () {
  console.log("pass to UF program");
  console.log(newPlan);

  updateNewPlanUI(newPlanMenuBtns, supplyProgramBtn, newPlanTableWindow, [
    newPlanNav,
  ]);
  lockEventListenersTable([newPlanNav]);

  unlockNav(supplyProgramBtn);

  checkNavBtns(supplyProgramBtn);

  //Get selected sector data
  const sectorSelected = findSelectedSector(
    originalSectorRows,
    newPlan.sectorId,
  );
  console.log("xxx1", sectorSelected);

  const selectedCropId = sectorSelected.cropId;
  console.log("xxx2", originalCropRows, newPlan, selectedCropId);
  newPlan.cropId = selectedCropId;
  const selectedCrop = findSelectedCrop(originalCropRows, selectedCropId);
  console.log("selectedCrop", selectedCrop);

  const sectorName = capitalizeFirstLetter(sectorSelected.name);
  const sectorCrop =
    `${selectedCrop.cropId} - ` + capitalizeFirstLetter(`${selectedCrop.crop}`);

  renderSectorData(newPlan.sectorAreaHa, sectorName, sectorCrop);

  renderTotalSupplyTable(sectorSelected.crop);

  renderCheckContinueBtn(newPlanTableWindow, "supplyValues");
  //checkContinueBtn("supplyValues");

  //Exit btn
  renderCheckExitBtn(
    newPlanNav,
    newPlanTableWindow,
    newPlanWindow,
    menuTagCurrBtn,
    account,
  );
};

const renderSectorData = function (sectorArea, sectorName, sectorCrop) {
  console.log(sectorCrop);
  const cropString = sectorCrop.slice(38);
  const markup = `
  <div class="new-plan-div new-plan-div-recap">
  <img src="/icons/menu-sector.jpg" alt="sector" class="menu__btn-icon">   
  <h3 class="new-plan-header new-plan-recap-header">RIEPILOGO DATI SETTORE</h3></div>
  <p>Settore: ${sectorName}</p>
  <p>Coltura settore: ${cropString} </p>
  <p>Superficie settore: ${sectorArea}ha - ${sectorArea * 10000}m2</p>`;

  newPlanTableWindow.insertAdjacentHTML("beforeend", markup);
};

const renderTotalSupplyTable = function (cropId) {
  //Create header
  const header = headerCrop.slice(2);

  const headerMarkup = header
    .map((h) => `<th>${h}</th>`)
    .toString("")
    .replaceAll(",", "");

  //Create crop suggested supply
  const selectedCrop = findSelectedCrop(originalCropRows, newPlan.cropId);

  const supplyRowMarkup = supplyKeys
    .map((key) => {
      console.log(key);
      const value = selectedCrop[key];
      console.log(value);
      return `<th>${value}</th>`;
    })
    .toString("")
    .replaceAll(",", "");

  //Create input supply row
  const supplyRowInputsMarkup = supplyKeys
    .map((key, i) => {
      return `<td><input name= "${key}" type="number"  placeholder="Inserire apporto" class="supplyInput supplyInput${i}"></td>`;
    })
    .toString("")
    .replaceAll(",", "");

  //Crate whole table
  const markup = `   
  <br>
  <div class="new-plan-div new-plan-div-tot">
  <img src="/icons/potion.jpg" alt="potion" class="menu__btn-icon">
  <h3 class="new-plan-header">PROGRAMMAZIONE APPORTI ANNUALI TOTALI PER ETTARO</h3></div>
  <table class="supplyTable" id="supplyTable">
            <tr class="supply-header">
            <th >Apporti</th>
                ${headerMarkup}
            </tr>
            <tr>
            <th >Apporti consigliati</th>
                ${supplyRowMarkup}
            </tr>
            <tr class="supply-input-row">
            <th >Apporti da programmare</th>
                ${supplyRowInputsMarkup}
            </tr>
            
        </table>`;
  newPlanTableWindow.insertAdjacentHTML("beforeend", markup);

  console.log(newPlan);
  console.log(newPlan.supplyProgram);
  if (newPlan.supplyProgram) {
    console.log("supplyProgram exists");
    console.log(supplyKeys);
    for (let i = 0; i < supplyKeys.length; i++) {
      document.querySelector(`.supplyInput${i}`).value =
        newPlan.supplyProgram[supplyKeys[i]];
    }
  }
  if (!newPlan.supplyProgram) {
    console.log("supplyProgram NOT exists");
  }
};

export const readSupplyTableValues = function () {
  const supplyRow = document.querySelector(".supply-input-row");
  const supplyInputs = supplyRow.getElementsByTagName("td");

  let supplyInputData = [];
  for (let i = 0; i < supplyInputs.length; i++) {
    const key = supplyKeys[i];
    const inputValue = supplyInputs[i].children[key].value;
    supplyInputData.push(inputValue);
  }

  checkSupplyInputValues(supplyInputData);
};

const checkSupplyInputValues = function (inputData) {
  const check = inputData.some((d) => d === "");

  //Not valid data
  if (check) {
    renderEmptyDataAlertWindow(
      "Dati incompleti: compilare tutti i campi prima di procedere.",
      newPlanTableWindow,
      "newPlan",
    );

    /* wrongSupplyInputWindow.classList.remove("hidden");
    lockEventListenersTable([newPlanNav, menuTag, newPlanTableWindow]);

    //Modal btn
    checkEmptyDataBtn(supplyInputModalBtn, wrongSupplyInputWindow, [
      newPlanNav,
      menuTag,
      newPlanTableWindow,
    ]);

    //Ok btn
    checkEmptyDataBtn(okSupplyInputBtn, wrongSupplyInputWindow, [
      newPlanNav,
      menuTag,
      newPlanTableWindow,
    ]);*/
  }

  //Valid data
  if (!check) {
    const supplyData = new Object();
    supplyKeys.map((key, i) => (supplyData[key] = inputData[i]));

    newPlan.supplyProgram = supplyData;
    console.log(newPlan);

    controlBasicProgram();
  }
};

//--------CONTROL BASIC FERTILIZATION PROGRAM SECTION------
//----------------------------------
//----------------------------------
const controlBasicProgram = function () {
  updateNewPlanUI(newPlanMenuBtns, ufPlanBtn, newPlanTableWindow, [
    newPlanNav,
    menuTag,
  ]);

  unlockNav(ufPlanBtn);

  checkNavBtns(ufPlanBtn);

  renderBasicSupplyTable();

  //Continue Btn
  renderCheckContinueBtn(newPlanTableWindow, "UfSupplyValues");
  //checkContinueBtn("UfSupplyValues");

  //Exit Btn
  renderCheckExitBtn(
    newPlanNav,
    newPlanTableWindow,
    newPlanWindow,
    menuTagCurrBtn,
    account,
  );
};

const renderBasicSupplyTable = function () {
  //Create header
  const header = [
    "Fase",
    "Fase fenologica - Periodo",
    "Prodotto",
    "Dose kg/ha",
    "Dose kg/settore",
    "€/ha",
    "€/settore",
  ];

  const headerMarkup = header
    .map((h) => `<th>${h}</th>`)
    .toString("")
    .replaceAll(",", "");

  console.log(newPlan);

  //Create rows
  let allRowsMarkup = "";

  for (let i = 0; i < rowsBasicNum; i++) {
    const singleRowMarkup = `<tr>
    <td class="uf-row-id">${i + 1}</td>

    <td><input class= "period${i}"      type="text"  placeholder="Inserire Fase-Periodo"></td>

  <td><select class="basic-product-select basic-product-select${i}" >
                <option value=""> --Selezionare Prodotto--</option>
                    </select></td>

                    <td><input type="number"  class="input-quantity-cell  input-quantity-cell${i}"  placeholder="Inserire  dose"></td>

                    <td class="calculated-quantity-cell calculated-qty-cell${i}"></td><td class="calculated-costHa"></td><td class="calculated-costSector"></td></tr>`;

    allRowsMarkup = allRowsMarkup + singleRowMarkup;
  }

  //Render table
  const markup = `   
  <br>
  <div class="new-plan-div new-plan-div-supply">
  <img src="/icons/menu-product1.jpg" alt="product" class="menu__btn-icon">
  <h3 class="new-plan-header">PROGRAMMAZIONE CONCIMAZIONE DI FONDO</h3>
  </div>
  <table class="supplyTable">
            <tr class="supply-header">
                ${headerMarkup}
            </tr>
            <tr>
                ${allRowsMarkup}
            </tr>
        </table>`;
  newPlanTableWindow.insertAdjacentHTML("afterbegin", markup);

  //Fill calculated cell when quantity changes
  document.addEventListener("change", function (event) {
    if (event.target.classList.contains("input-quantity-cell")) {
      let row = event.target.closest("tr");
      let inputValue = parseFloat(event.target.value) || 0;

      row.querySelector(".calculated-quantity-cell").textContent = (
        inputValue * newPlan.sectorAreaHa
      ).toFixed(2);
      console.log("quantity calculated");
      //If product is already selected--> calc costs
      if (row.querySelector(`.basic-product-select`).value) {
        console.log(
          "Product selected: ",
          row.querySelector(`.basic-product-select`).value,
        );

        /*const currProduct = row
          .querySelector(`.basic-product-select`)
          .value.slice(0, 36);*/

        const selectElement = row.querySelector(`.basic-product-select`);
        const selectedOption =
          selectElement.options[selectElement.selectedIndex];
        const currProduct = selectedOption.dataset.productId;
        console.log("currProduct: ", currProduct);
        console.log(
          "currProduct value: ",
          row.querySelector(`.basic-product-select`).value,
        );
        let currPriceList;
        console.log("product: ", originalProductRows);
        originalProductRows.forEach((product) => {
          if (product.productId === currProduct) {
            console.log("product: ", product);
            console.log("product.productId: ", product.productId);
            console.log(product.countEurokg);
            product.countEurokg.forEach((priceList) => {
              if (priceList[0] === newPlan.companyId) {
                console.log("CompanyId: ", priceList[0]);
                currPriceList = priceList[1];
              }
            });
          }
        });
        console.log("CurrPriceList: ", currPriceList);
        if (!currPriceList) {
          console.log("currPriceList not exists");
          row.querySelector(".calculated-costHa").textContent = "-";

          console.log(
            "Cost ha:",
            row.querySelector(".calculated-costHa").textContent,
          );

          row.querySelector(".calculated-costSector").textContent = "-";
        }
        if (currPriceList) {
          console.log("currPriceList: ", currPriceList);
          console.log(currPriceList);
          //Calc costs
          row.querySelector(".calculated-costHa").textContent = (
            (row.querySelector(".calculated-quantity-cell").textContent /
              newPlan.sectorAreaHa) *
            currPriceList
          ).toFixed(2);

          console.log(
            "Cost ha:",
            row.querySelector(".calculated-costHa").textContent,
          );

          row.querySelector(".calculated-costSector").textContent = (
            row.querySelector(".calculated-quantity-cell").textContent *
            currPriceList
          ).toFixed(2);
        }
      }
    }
  });

  //Fill calculated cell when products change
  document.addEventListener("change", function (event) {
    if (event.target.classList.contains("basic-product-select")) {
      let row = event.target.closest("tr");
      let inputValue = event.target.value;
      /*
      row.querySelector(".calculated-quantity-cell").textContent = (
        inputValue * newPlan.sectorAreaHa
      ).toFixed(2);
      console.log("quantity calculated");*/
      //If quantity is already filled--> calc costs
      if (row.querySelector(`.input-quantity-cell`).value) {
        console.log(
          "Quantity filled: ",
          row.querySelector(`.input-quantity-cell`).value,
        );

        const currProduct = row
          .querySelector(`.basic-product-select`)
          .value.slice(0, 36);
        let currPriceList;
        originalProductRows.forEach((product) => {
          if (product.productId === currProduct) {
            console.log(product.countEurokg);
            product.countEurokg.forEach((priceList) => {
              if (priceList[0] === newPlan.companyId) {
                console.log("CompanyId: ", priceList[0]);
                currPriceList = priceList[1];
              }
            });
          }
        });
        console.log("CurrPriceList: ", currPriceList);
        if (!currPriceList) {
          console.log("currPriceList not exists");
          row.querySelector(".calculated-costHa").textContent = "-";

          console.log(
            "Cost ha:",
            row.querySelector(".calculated-costHa").textContent,
          );

          row.querySelector(".calculated-costSector").textContent = "-";
        }
        if (currPriceList) {
          //Calc costs
          row.querySelector(".calculated-costHa").textContent = (
            (row.querySelector(".calculated-quantity-cell").textContent /
              newPlan.sectorAreaHa) *
            currPriceList
          ).toFixed(2);

          console.log(
            "Cost ha:",
            row.querySelector(".calculated-costHa").textContent,
          );

          row.querySelector(".calculated-costSector").textContent = (
            row.querySelector(".calculated-quantity-cell").textContent *
            currPriceList
          ).toFixed(2);
        }
      }
    }
  });

  createSelectProduct("product");

  //Fill with newPlan values, if it exists
  const supplyTable = document.querySelector(".supplyTable");
  console.log(newPlan.ufBaseSupply);

  if (newPlan.ufBaseSupply) {
    newPlan.ufBaseSupply.forEach((row, i) => {
      const tableRow = supplyTable.rows[i + 2];
      tableRow.querySelector(`.period${i}`).value = row.period;

      //Get product option
      let productString;
      console.log(originalProductRows);
      /*originalProductRows.forEach((product) => {
        if (product.productId === row.ufProduct) {
          productString = `${product.productId} - ${product.product} - ${product.countN}.${product.countP2O5}.${product.countK2O}.${product.countCaO}.${product.countMgO}.${product.countSO3}`;
        }
      });
      console.log(productString);

      tableRow.querySelector(`.basic-product-select`).value = productString;*/

      const selectElement = tableRow.querySelector(`.basic-product-select`);
      const optionToSelect = Array.from(selectElement.options).find(
        (option) => option.dataset.productId === row.ufProduct,
      );
      if (optionToSelect) {
        selectElement.value = optionToSelect.value;
      }
      console.log(tableRow.querySelector(`.basic-product-select`));
      tableRow.querySelector(`.input-quantity-cell`).value = row.haQuantity;
      tableRow.querySelector(`.calculated-quantity-cell`).textContent =
        row.sectorQuantity;
      if (row.costHa) {
        tableRow.querySelector(`.calculated-costHa`).textContent = row.costHa;

        tableRow.querySelector(`.calculated-costSector`).textContent =
          row.costSector;
      }
      if (!row.costHa) {
        tableRow.querySelector(`.calculated-costHa`).textContent = "-";

        tableRow.querySelector(`.calculated-costSector`).textContent = "-";
      }
    });
  }
};

export const readBasicSupplyTableValues = function () {
  console.log("readBasicData");
  //Read data
  const rowsId = Array.from(document.querySelectorAll(".uf-row-id"));

  const ufSupplyValues = [];
  let missingPriceListString = "";
  missingPriceListStringBase = "";
  rowsId.forEach((rowId, i) => {
    const ufSupplyRow = new Object();
    //Find ALL INPUT ELEMENTS for the current row
    ufSupplyRow.rowId = i;
    const row = rowId.closest("tr");
    const inputs = Array.from(row.querySelectorAll("input"));

    //Read INPUT PERIOD for the current row
    inputs.forEach((input) => {
      const inputPeriodClass = `period${i}`;

      if (input.classList.contains(inputPeriodClass)) {
        ufSupplyRow.period = input.value;
      }
    });

    //Read INPUT HA QUANTITY for the current row
    const inputHaQty = inputs.find((input) => {
      const inputHaQtyClass = `input-quantity-cell${i}`;

      if (input.classList.contains(inputHaQtyClass)) {
        ufSupplyRow.haQuantity = input.value;
      }
    });

    //Read CALCULATED SECTOR QUANTITY for the current row
    const calcQtyEl = row.querySelector(".calculated-quantity-cell");
    ufSupplyRow.sectorQuantity = calcQtyEl.textContent;

    //Read SELECTED PRODUCT for the current row
    const selectProduct = row.querySelector(".basic-product-select");
    const selectedProduct =
      selectProduct.options[selectProduct.selectedIndex].dataset.productId;
    ufSupplyRow.ufProduct = selectedProduct;

    //Read PRICE LIST for the current product/company
    console.log(selectedProduct, newPlan.companyId);

    originalProductRows.forEach((product) => {
      if (product.productId === selectedProduct) {
        console.log(product.countEurokg);

        let validPriceList = "";

        if (!product.countEurokg) {
        }
        if (product.countEurokg) {
          product.countEurokg.forEach((priceList) => {
            if (priceList[0] === newPlan.companyId) {
              validPriceList = priceList;
            }
          });
        }

        console.log(validPriceList);
        if (validPriceList === "") {
          console.log("error: missing price list");
          if (missingPriceListString !== "") {
            if (!missingPriceListString.includes(selectProduct.value.slice(37)))
              missingPriceListString =
                missingPriceListString + `, ${selectProduct.value.slice(37)}`;
          }
          if (missingPriceListString === "") {
            missingPriceListString = `${selectProduct.value.slice(37)}`;
          }
        }
        if (validPriceList !== "") {
          console.log("price list");
          console.log(validPriceList[1]);
          ufSupplyRow.validPrice = validPriceList[1];
          ufSupplyRow.costHa = ufSupplyRow.validPrice * ufSupplyRow.haQuantity;
          ufSupplyRow.costSector =
            ufSupplyRow.validPrice * ufSupplyRow.sectorQuantity;
        }
      }
    });

    //Add currentRow values to ufSupplyValues array
    ufSupplyValues.push(ufSupplyRow);
  });

  if (missingPriceListString !== "") {
    renderEmptyDataAlertWindow(
      `Prezzo mancante per: ${missingPriceListString}. Se il prezzo non è inserito, non vengono calcolati i costi per il piano. Per ottenere il calcolo dei costi, inserire il prezzo in anagrafica prodotto PRIMA di inserire il piano.`,
      newPlanTableWindow,
      "newPlan",
    );
    missingPriceListStringBase = missingPriceListString;
  }
  if (missingPriceListString === "") {
    console.log("all valid costs");
    console.log(ufSupplyValues);
  }

  //Check data
  const validRows = [];
  const notValidRows = [];
  console.log("ufSupplyValues", ufSupplyValues);
  ufSupplyValues.forEach((ufSupplyValue) => {
    console.log(
      "ufSupplyValue.haQuantity",
      ufSupplyValue,
      ufSupplyValue.period &&
        ufSupplyValue.haQuantity !== "0" &&
        ufSupplyValue.sectorQuantity &&
        ufSupplyValue.ufProduct,
    );
    if (
      (!!ufSupplyValue.period &&
        //ufSupplyValue.haQuantity !== "0" &&
        !!ufSupplyValue.sectorQuantity &&
        !!ufSupplyValue.ufProduct) |
      (!ufSupplyValue.period &&
        !ufSupplyValue.haQuantity &&
        !ufSupplyValue.sectorQuantity &&
        !ufSupplyValue.ufProduct)
    ) {
      validRows.push(true);
      console.log("validRows", validRows);
    } else {
      if (
        !ufSupplyValue.period |
        !ufSupplyValue.haQuantity |
        !ufSupplyValue.sectorQuantity |
        !ufSupplyValue.ufProduct
        //|(ufSupplyValue.haQuantity === "0")
      ) {
        notValidRows.push(ufSupplyValue.rowId + 1);
        console.log("notValidRows", notValidRows);
      }
    }
  });

  console.log("validRows xxx", ufSupplyValues, validRows);

  //All rows valid
  if (ufSupplyValues.length === validRows.length) {
    const filledRows = checkFilledRows(ufSupplyValues);
    newPlan.ufBaseSupply = filledRows;
    console.log(newPlan);

    checkValidPriceListBase(newPlan.ufBaseSupply);
    /*
    //Check valid price list for calc cost
    const validPriceRow = [];
    newPlan.ufBaseSupply.forEach((row) => {
      if (row.validPrice) validPriceRow.push(row);
    });
    if (validPriceRow.length === newPlan.ufBaseSupply.length) {
      //Calc cost
      let haCost = 0;
      let sectorCost = 0;
      newPlan.ufBaseSupply.forEach((row) => {
        //Get product cost
        const currProductId = row.ufProduct;
        let productCost;
        originalProductRows.forEach((product) => {
          if (product.productId === currProductId) {
            productCost = row.validPrice;
          }
        });
        console.log(productCost);
        console.log(row.haQuantity, row.sectorQuantity);
        haCost = (
          Number(haCost) + Number(row.haQuantity * productCost)
        ).toFixed(2);
        sectorCost = (
          Number(sectorCost) + Number(row.sectorQuantity * productCost)
        ).toFixed(2);
      });
      console.log(haCost, sectorCost);
      newPlan.ufBaseTotHaCost = haCost;
      newPlan.ufBaseTotSectorCost = sectorCost;
    }
    if (validPriceRow.length !== newPlan.ufBaseSupply.length) {
      newPlan.ufBaseTotHaCost = 0;
      newPlan.ufBaseTotSectorCost = 0;
    }
    console.log(newPlan);*/
    controlFertiProgram();
  }
  if (ufSupplyValues.length !== validRows.length) {
    const notValidRowsString = notValidRows.join("-");

    const msg = `Inserire tutti i valori richiesti prima di continuare (riga ${notValidRowsString}).`;
    renderEmptyDataAlertWindow(msg, newPlanTableWindow, "newPlan");
  }
};

const checkValidPriceListBase = function (ufBaseSupply) {
  console.log("check valid price list");
  //Check valid price list for calc cost
  const validPriceRow = [];
  ufBaseSupply.forEach((row) => {
    if (row.validPrice) validPriceRow.push(row);
  });
  if (validPriceRow.length === ufBaseSupply.length) {
    //Calc cost
    let haCost = 0;
    let sectorCost = 0;
    ufBaseSupply.forEach((row) => {
      //Get product cost
      const currProductId = row.ufProduct;
      let productCost;
      originalProductRows.forEach((product) => {
        if (product.productId === currProductId) {
          productCost = row.validPrice;
        }
      });
      console.log(productCost);
      console.log(row.haQuantity, row.sectorQuantity);
      haCost = (Number(haCost) + Number(row.haQuantity * productCost)).toFixed(
        2,
      );
      sectorCost = (
        Number(sectorCost) + Number(row.sectorQuantity * productCost)
      ).toFixed(2);
    });
    console.log(haCost, sectorCost);
    newPlan.ufBaseTotHaCost = haCost;
    newPlan.ufBaseTotSectorCost = sectorCost;
  }
  if (validPriceRow.length !== newPlan.ufBaseSupply.length) {
    newPlan.ufBaseTotHaCost = "-";
    newPlan.ufBaseTotSectorCost = "-";
  }
  console.log(newPlan);
};

export const renderEmptyDataAlertWindow = function (msg, window, type) {
  console.log(emptyDataHeading);
  emptyDataHeading.textContent = "";
  emptyDataHeading.textContent = msg;

  emptyDataAlertWindow.classList.remove("hidden");

  let array = [];
  if (type === "newPlan") {
    array = [newPlanNav, menuTag, window];
  }
  if (type === "openPlan") {
    array = [menuTag, window];
  }
  if (type === "product") {
    array = [menuTag, window];
  }

  lockEventListenersTable(array);

  //Modal Btn
  const emptyDataModalBtn = document.querySelector(".empty-data_modal");
  checkEmptyDataBtn(emptyDataModalBtn, emptyDataAlertWindow, array);

  //Close btn
  const emptyDataBtn = document.querySelector(".empty-data__btn");
  checkEmptyDataBtn(emptyDataBtn, emptyDataAlertWindow, array);
};

//--------CONTROL FERTI PROGRAM SECTION------
//----------------------------------
//----------------------------------
const controlFertiProgram = function () {
  updateNewPlanUI(newPlanMenuBtns, fertiPlanBtn, newPlanTableWindow, [
    newPlanNav,
    menuTag,
  ]);

  unlockNav(fertiPlanBtn);

  checkNavBtns(fertiPlanBtn);

  renderTotSupplyTable();

  renderFertiPlanTable();
  checkFertiTableData();

  //Continue Btn
  renderCheckContinueBtn(newPlanTableWindow, "fertiPlan");
  //Exit Btn
  renderCheckExitBtn(
    newPlanNav,
    newPlanTableWindow,
    newPlanWindow,
    fertiPlanBtn,
    account,
  );
};

const checkFilledRows = function (ufSupplyValues) {
  console.log("ufSupplyValues", ufSupplyValues);
  const filledRows = ufSupplyValues.filter(
    (ufSupplyValue) =>
      ufSupplyValue.period !== "" &&
      ufSupplyValue.haQuantity !== "" &&
      ufSupplyValue.sectorQuantity !== "" &&
      ufSupplyValue.ufProduct !== "",
  );
  console.log("filledRows", filledRows);
  const filledRowsUpdatedId = filledRows.map((row, i) => {
    row.rowId = i;
    return row;
  });
  console.log("filledRowsUpdatedId", filledRowsUpdatedId);
  return filledRowsUpdatedId;
};

const renderTotSupplyTable = function () {
  //Create header
  const header = headerCrop.slice(2);

  const headerMarkup = header
    .map((h) => `<th>${h}</th>`)
    .toString("")
    .replaceAll(",", "");

  //Create rows
  //1st row: tot supply
  let totSupplyRowMarkup = "";
  const varStrArrayTot = header.map((h) => {
    const varStr = `count${h}`;
    return varStr;
  });

  const totSupplyRow = varStrArrayTot.map((varStr) => {
    const value = newPlan.supplyProgram[varStr];
    return value;
  });

  totSupplyRowMarkup = totSupplyRow
    .map((v) => `<th>${v}</th>`)
    .toString("")
    .replaceAll(",", "");

  //2nd row: basic supply
  createUfBaseSupplyPerHa(varStrArrayTot);

  let ufSupplyRowMarkup = "";

  const ufSupplyRow = varStrArrayTot.map((varStr) => {
    const value = newPlan.ufBaseSupplyPerHa[varStr];
    return value;
  });

  ufSupplyRowMarkup = ufSupplyRow
    .map((v) => `<th>${v}</th>`)
    .toString("")
    .replaceAll(",", "");

  //3rd row: ferty supply to plan
  createFertiSupplyPerHa(varStrArrayTot);
  let fertiSupplyRowMarkup = "";
  const fertiSupplyRow = varStrArrayTot.map((varStr) => {
    const value = newPlan.fertiSupplyPerHa[varStr];
    return value;
  });

  fertiSupplyRowMarkup = fertiSupplyRow
    .map((v) => `<th>${v}</th>`)
    .toString("")
    .replaceAll(",", "");

  //4th row: ferty supply planned
  const fertiSupplyPlanRow = varStrArrayTot.map(
    (varStr) => `<th class=tot-plan-${varStr}>0</th>`,
  );
  const fertiSupplyPlanRowMarkup = fertiSupplyPlanRow
    .toString("")
    .replaceAll(",", "");

  //5th row: ferty supply var
  const fertiSupplyVarRow = varStrArrayTot.map(
    (varStr) =>
      `<th class=tot-var-${varStr}>${newPlan.fertiSupplyPerHa[varStr]}</th>`,
  );
  const fertiSupplyVarRowMarkup = fertiSupplyVarRow
    .toString("")
    .replaceAll(",", "");

  //Render table
  const markup = `   
  <br>
  <div class="new-plan-div new-plan-div-tot">
  <img src="/icons/potion.jpg" alt="potion" class="menu__btn-icon">
  <h3 class="new-plan-header">RIEPILOGO APPORTI PER ETTARO</h3></div>
  <table class="tot-supplyTable">
            <tr class="tot-supply-header">
            <th >APPORTI</th>
                ${headerMarkup}
            </tr>
            <tr>
            <th >Apporti totali programmati</th>
                ${totSupplyRowMarkup}
            </tr>
            <tr class="tot-supply-input-row">
            <th >Apporti da CONCIMI DI FONDO programmati</th>
                ${ufSupplyRowMarkup}
            </tr>
            <tr class="tot-supply-plan-row">
            <th >Apporti da FERTIRRIGAZIONE DA PROGRAMMARE</th>
                ${fertiSupplyRowMarkup}
            </tr>
            <tr class="tot-supply-planned-row">
            <th >Apporti da FERTIRRIGAZIONE PROGRAMMATI</th>
                ${fertiSupplyPlanRowMarkup}
            </tr>
            <tr class="delta-supply-plan-row">
            <th >RESIDUO apporti da FERTIRRIGAZIONE DA PROGRAMMARE</th>
                ${fertiSupplyVarRowMarkup}
            </tr>
            
        </table>`;
  newPlanTableWindow.insertAdjacentHTML("afterbegin", markup);

  //If newPlan already exists, fill the cells
  if (newPlan.fertiPlanData.length !== 0) {
    console.log("fertiPlanData already exists");
    const totSupplyTable = document.querySelector(".tot-supplyTable");

    varStrArrayTot.forEach((str, i) => {
      console.log(totSupplyTable.rows[4].querySelector(`.tot-plan-${str}`));
      totSupplyTable.rows[4].querySelector(`.tot-plan-${str}`).textContent =
        newPlan.totPlanSupply[i];
    });
  }
};

const createUfBaseSupplyPerHa = function (ufStr) {
  const singleUfBaseSupplyPerHa = [];

  newPlan.ufBaseSupply.forEach((baseSupply, i) => {
    //Get data from single baseSupply
    const selectedProductId = baseSupply.ufProduct;
    const inputUfHaQty = baseSupply.haQuantity;

    const selectedProductRow = findSelectedProduct(
      originalProductRows,
      selectedProductId,
    );

    //Calculate single baseSupply per Ha
    const ufBaseSupplyPerHaRow = new Object();
    ufStr.forEach((ufStr) => {
      ufBaseSupplyPerHaRow[ufStr] =
        (selectedProductRow[ufStr] * inputUfHaQty) / 100;
    });
    singleUfBaseSupplyPerHa[i] = ufBaseSupplyPerHaRow;
  });
  newPlan.ufBaseSupplyPerProductPerHa = singleUfBaseSupplyPerHa;

  //Calculate tot supply per Ha
  const totSupply = new Object();
  ufStr.forEach((ufStr) => (totSupply[ufStr] = 0));

  ufStr.forEach((ufStr) => {
    singleUfBaseSupplyPerHa.forEach((ufBaseSupply) => {
      totSupply[ufStr] = (
        Number(totSupply[ufStr]) + Number(ufBaseSupply[ufStr])
      ).toFixed(2);
    });
  });

  newPlan.ufBaseSupplyPerHa = totSupply;
};

const createFertiSupplyPerHa = function (varStrArrayTot) {
  newPlan.fertiSupplyPerHa = new Object();

  varStrArrayTot.forEach((varStr) => {
    const fertiSupply = (
      newPlan.supplyProgram[varStr] - newPlan.ufBaseSupplyPerHa[varStr]
    ).toFixed(2);
    newPlan.fertiSupplyPerHa[varStr] = fertiSupply;
  });
};

const renderFertiPlanTable = function () {
  //Create header
  const header = [
    "Fase",
    "Fase fenologica - Periodo",
    "Prodotto",
    "Dose per interv. kg/ha",
    "Numero interv.",
    "Concentr. sulla pianta g/l",
    "Volume soluz. madre per interv. l",
    "Concentraz. prodotto sul volume d'acqua pura per intervento %p/v",
    "Conducib. reale mS/cm",
    "Costo a periodo per ha €/ha",
    "Costo a periodo per settore €/settore",
  ];

  const headerMarkup = header
    .map((h) => `<th>${h}</th>`)
    .toString("")
    .replaceAll(",", "");

  //Create rows
  const totRows = rowsNum * productsForPhase;

  let allRowsMarkup = "";

  for (let i = 0; i < totRows; i++) {
    let singleRowMarkup;
    const phaseCounter = i / 6 + 1;
    const selectProductMarkup = `<select class="uf-product-select uf-product-select${
      i + 1
    }" >
    <option value=""> --Selezionare Prodotto--</option>
      </select>`;

    const markupSelectProd = `<td>${selectProductMarkup}</td>`;
    const markupSupply = `<td><input class= "supply supply${
      i + 1
    }" id="supplyPerInt" type="number" placeholder="Inserire"></td>`;
    const markupCalcConc = `<td class="calculated-conc "></td>`;
    const markupCalcCond = `<td class="calculated-cond "></td>`;

    if ((i === 0) | (i % productsForPhase === 0)) {
      singleRowMarkup = `<tr>
    <td class="unique-cell phase-counter">${phaseCounter}</td>
    <td class="unique-cell"><input class= "period period${phaseCounter}"      type="text"  placeholder="Inserire Fase"></td>
    
    ${markupSelectProd}
    ${markupSupply}

    <td class="unique-cell"><input class= "intNum intNum${phaseCounter}"      type="number"  placeholder="Inserire"></td>

    <td class="unique-cell"><input class= "concPlant concPlant${phaseCounter}"      type="number"  placeholder="Inserire"></td>

    <td class="unique-cell calculated-mother-volume calculated-mother-volume${phaseCounter}"></td>
    
    ${markupCalcConc}
    ${markupCalcCond}
    <td class="unique-cell calculated-cost-ha calculated-cost-ha${phaseCounter}"></td>
    <td class="unique-cell calculated-cost-sector calculated-cost-sector${phaseCounter}"></td>

    </tr>`;
    } else {
      singleRowMarkup = `<tr>
  
      ${markupSelectProd}
      ${markupSupply}
      ${markupCalcConc}
      ${markupCalcCond}
      </tr>`;
    }
    allRowsMarkup = allRowsMarkup + singleRowMarkup;
  }

  const fertiSectionMarkup = `<div class="ferti_table_window">
  </div>`;
  newPlanTableWindow.insertAdjacentHTML("beforeend", fertiSectionMarkup);

  fertiTableWindow = document.querySelector(".ferti_table_window");

  const markup1 = `   
    <br>
    <br>
    <div class="new-plan-div new-plan-div-tot">
  <img src="/icons/menu-fertiproduct2.jpg" alt="fertiproduct" class="menu__btn-icon">
    <h3 class="new-plan-header">PROGRAMMAZIONE PRODOTTI DI FERTIRRIGAZIONE</h3></div>`;
  fertiTableWindow.insertAdjacentHTML("afterbegin", markup1);

  const markup2 = `
  <table class="supply-table">
            <tr class="supply-header">
                ${headerMarkup}
            </tr>
            
            ${allRowsMarkup}
            
        </table>`;
  fertiTableWindow.insertAdjacentHTML("beforeend", markup2);

  //Render multiple rows
  const multipleRow = document.querySelectorAll(".unique-cell");
  multipleRow.forEach((row) => (row.rowSpan = 6));
  createSelectProduct("fertiProduct");

  //If newPlan already exists, fill the cells
  if (newPlan.fertiPlanData.length !== 0) {
    console.log("fertiplanData exists - fertiTable");
    const fertiTable = document.querySelector(".supply-table");
    console.log(fertiTable);
    console.log(fertiTable.rows[1]);

    for (let i = 0; i < newPlan.fertiPlanTotData.length; i++) {
      newPlan.fertiPlanTotData.forEach((phaseTotData) => {
        let currPhase, minPhaseRow, maxPhaseRow;
        if (phaseTotData.phase === i + 1) {
          newPlan.fertiPlanData.forEach((phaseData) => {
            if (phaseData.phase === i + 1) {
              [currPhase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(
                phaseData.rowId,
              );
              for (let row = minPhaseRow; row <= maxPhaseRow; row++) {
                if (phaseData.rowId === row) {
                  fertiTable.rows[row].querySelector(
                    ".uf-product-select",
                  ).value = phaseData.product;
                  fertiTable.rows[row].querySelector(".supply").value =
                    phaseData.supply;
                  fertiTable.rows[row].querySelector(
                    ".calculated-conc",
                  ).textContent = phaseData.concProdInt;
                  fertiTable.rows[row].querySelector(
                    ".calculated-cond",
                  ).textContent = phaseData.realCond;
                }
              }

              fertiTable.rows[minPhaseRow].querySelector(".period").value =
                phaseData.period;
              fertiTable.rows[minPhaseRow].querySelector(".intNum").value =
                phaseData.intNum;
              fertiTable.rows[minPhaseRow].querySelector(".concPlant").value =
                phaseData.concPlant;
            }
          });

          //const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(phaseData.rowId);

          fertiTable.rows[minPhaseRow].querySelector(
            ".calculated-mother-volume",
          ).textContent = phaseTotData.motherSolVol;
          fertiTable.rows[minPhaseRow].querySelector(
            ".calculated-cost-ha",
          ).textContent = phaseTotData.totCostHa;
          fertiTable.rows[minPhaseRow].querySelector(
            ".calculated-cost-sector",
          ).textContent = phaseTotData.totCostSector;
        }
      });
    }
    /*
    fertiTable.rows[1].querySelector(".uf-product-select").value =
      newPlan.fertiPlanData[0].product;
    fertiTable.rows[1].querySelector(".supply").value =
      newPlan.fertiPlanData[0].supply;
    fertiTable.rows[1].querySelector(".calculated-conc").textContent =
      newPlan.fertiPlanData[0].concProdInt;
    fertiTable.rows[1].querySelector(".calculated-cond").textContent =
      newPlan.fertiPlanData[0].realCond;

    const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(1);
    fertiTable.rows[minPhaseRow].querySelector(".period").value =
      newPlan.fertiPlanData[0].period;
    fertiTable.rows[minPhaseRow].querySelector(".intNum").value =
      newPlan.fertiPlanData[0].intNum;
    fertiTable.rows[minPhaseRow].querySelector(".concPlant").value =
      newPlan.fertiPlanData[0].concPlant;
    fertiTable.rows[minPhaseRow].querySelector(
      ".calculated-mother-volume"
    ).textContent = newPlan.fertiPlanTotData[0].motherSolVol;
    fertiTable.rows[minPhaseRow].querySelector(
      ".calculated-cost-ha"
    ).textContent = newPlan.fertiPlanTotData[0].totCostHa;
    fertiTable.rows[minPhaseRow].querySelector(
      ".calculated-cost-sector"
    ).textContent = newPlan.fertiPlanTotData[0].totCostSector;*/
  }
};

const checkFertiTableData = function () {
  //Check input period
  document.addEventListener("change", function (event) {
    if (event.target.classList.contains("period")) {
      const currRow = event.target.closest("tr");
      const currRowIndex = currRow.rowIndex;
      console.log(currRowIndex);
      const period = event.target.value;
      checkPeriodValue(period, currRowIndex, currRow);
    }
  });

  //Check ferti product select
  document.addEventListener("change", function (event) {
    if (event.target.classList.contains("uf-product-select")) {
      const currRow = event.target.closest("tr");
      const currRowIndex = currRow.rowIndex;
      const fertiProduct = event.target.value;
      const productId =
        event.target.selectedOptions?.[0]?.dataset?.productId ??
        event.target.options?.[event.target.selectedIndex]?.dataset?.productId;

      console.log("fertiProduct :", fertiProduct);
      console.log("productId :", productId);
      updateFertiProductValue(currRow, currRowIndex, fertiProduct, productId);
    }
  });

  //Check ferti product supply input
  document.addEventListener("change", function (event) {
    if (event.target.classList.contains("supply")) {
      //Find period for the current row
      const currRow = event.target.closest("tr");
      const currRowIndex = currRow.rowIndex;

      const supply = event.target.value;

      updateSupplyValue(supply, currRowIndex, currRow);
    }
  });

  //Check interv. input
  document.addEventListener("change", function (event) {
    if (event.target.classList.contains("intNum")) {
      const currRow = event.target.closest("tr");
      const currRowIndex = currRow.rowIndex;

      const intNum = event.target.value;

      updateIntNumValue(intNum, currRowIndex, currRow);
    }
  });

  //Check concPlant
  document.addEventListener("change", function (event) {
    if (event.target.classList.contains("concPlant")) {
      const currRow = event.target.closest("tr");
      const currRowIndex = currRow.rowIndex;

      const concPlant = event.target.value;

      console.log(currRowIndex);
      updateConcPlantValue(currRow, currRowIndex, concPlant);
    }
  });
};

const checkPeriodValue = function (period, currRowIndex, currRow) {
  console.log(period);
  const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(currRowIndex);

  //Deleted period
  if (!period) {
    console.log("empty period");

    //Count rows in fertiPlanData for the current Phase with fertiProd
    let countValidRows = 0;
    newPlan.fertiPlanData.forEach((phaseData) => {
      if (
        phaseData.rowId >= minPhaseRow &&
        phaseData.rowId <= maxPhaseRow &&
        phaseData.product
      ) {
        console.log(phaseData.rowId);
        countValidRows++;
        console.log(countValidRows);
      }
    });
    console.log(countValidRows);
    /*
    //Count rows in fertiPlanData for the current Phase
    let countPhaseRows = 0;
    newPlan.fertiPlanData.forEach((phaseData) => {
      if (phaseData.rowId >= minPhaseRow && phaseData.rowId <= maxPhaseRow)
        countPhaseRows++;
    });
    console.log(countPhaseRows);*/

    //Any row with fertiProduct-->delete current PhaseData from fertiPlanData
    if (countValidRows === 0) {
      console.log("any phase row with fertiprod");
      console.log(currRowIndex);
      removePhaseData([currRowIndex]);
      //replaceRemovedPhase(phase);
      //updateDataTable();
      //Find multiple cell row
      //Render empty period
      const supplyTable = document.querySelector(".supply-table");

      const multipleRow = supplyTable.rows[minPhaseRow];

      multipleRow.querySelector(".period").value = "";
    }
    //At least 1 row with fertiProduct-> error msg
    if (countValidRows >= 1) {
      console.log("at least 1 valid row with ferti product exists");
      renderCheckConfirmWindow(
        "Attenzione: è stata cancellata la descrizione di Fase fenologica-Periodo. Se si conferma, tutti i dati della fase verranno cancellati (es. Prodotto, Dose...). Confermare?",
        ["deletePhaseDataObj", currRowIndex, currRow],
      );
    }
  }
  if (period) updatePeriodValue(currRowIndex, period);

  console.log(newPlan);
};

/*
const checkProductValue = function (fertiProduct, currRowIndex, currRow) {
  console.log(fertiProduct);
  const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(currRowIndex);

  //Deleted fertiProduct
  if (!fertiProduct) {
    console.log("empty fertiProduct");

    //Supply exists for the current phaseData

    //Supply deosn't exist for the current phaseData

    //Any row with fertiProduct-->delete current PhaseData from fertiPlanData
    if (countEmptyRows === countPhaseRows) {
      console.log("any phase row with fertiprod");
      console.log(currRowIndex);
      removePhaseData([currRowIndex]);
      replaceRemovedPhase(phase);
      updateDataTable();
    }
    //At least 1 row with fertiProduct-> error msg
    if (countEmptyRows < countPhaseRows) {
      console.log(newPlan.fertiPlanData);
      renderCheckConfirmWindow(
        "Attenzione: è stata cancellata la descrizione di Fase fenologica-Periodo. Se si conferma, tutti i dati della fase verranno cancellati (es. Prodotto, Dose...). Confermare?",
        ["deletePhaseDataObj", currRowIndex, currRow]
      );
    }
  }
  if (fertiProduct) updateProductValue(currRowIndex, fertiProduct);
  console.log(newPlan);
};*/

const removePhaseTotData = function (phase) {
  console.log(phase);
  const indexPhaseTotDataToRemove = newPlan.fertiPlanTotData.findIndex(
    (phaseTotData) => phaseTotData.phase === phase,
  );
  console.log(indexPhaseTotDataToRemove);
  newPlan.fertiPlanTotData.splice(indexPhaseTotDataToRemove, 1);
  console.log(newPlan.fertiPlanTotData);
  console.log(newPlan);
};

const updatePeriodValue = function (currRowIndex, period) {
  console.log("update period value");
  //Check if phaseData for the current period already exists
  //Check if a phaseData with the same phase exists
  const currentPhase = (currRowIndex - 1) / productsForPhase + 1;

  let currentPhaseIndex = [];
  newPlan.fertiPlanData.forEach((data) => {
    if (data.phase === currentPhase) {
      currentPhaseIndex.push(data.rowId);
    }
  });
  console.log(currentPhase, currentPhaseIndex);

  //If it exists-->update period in each phaseData
  if (currentPhaseIndex.length !== 0) {
    console.log("currentPhaseIndex exists");

    currentPhaseIndex.forEach((index) => {
      newPlan.fertiPlanData.forEach((phaseData) => {
        if (phaseData.rowId === index) {
          phaseData.period = period;
        }
      });
    });
  }
  //If it doesn't exists-->create new phaseData for the current period
  if (currentPhaseIndex.length === 0) {
    const phaseData = new Object();
    phaseData.rowId = currRowIndex;
    phaseData.phase = (currRowIndex - 1) / productsForPhase + 1;
    phaseData.period = period;
    newPlan.fertiPlanData.push(phaseData);
    console.log(newPlan.fertiPlanData);
  }
  console.log(newPlan);
};
/*
const updateProductValue = function (currRowIndex, fertiProduct) {
  console.log("update fertiProduct value");

  /*
  //Check if a phaseData with the same phase exists
  const currentPhase = (currRowIndex - 1) / productsForPhase + 1;

  let currentPhaseIndex = [];
  fertiPlanData.forEach((data) => {
    if (data.phase === currentPhase) {
      currentPhaseIndex.push(data.rowId);
    }
  });
  console.log(currentPhase, currentPhaseIndex);
  */

//Check if period exists
/*
  if(period){
    vado avanti
  }
  if(!period){
    error msg
  }*/
//Check if phaseData for the current index already exists

//If it exists-->update period in each phaseData
/*
  const currPhaseData = newPlan.fertiPlanData.filter((phaseData) => {
    if (phaseData.rowId === currRowIndex) {
    }
  });
  console.log(currPhaseData);

  if (currPhaseData) {
    console.log("currentPhaseData exists");
    //Check if supply and intNum exist for the current phaseData

    //Update fertiProductValue in fertiPlanData
    newPlan.fertiPlanData.forEach((phaseData) => {
      if (phaseData.rowId === currRowIndex) {
        phaseData.fertiProduct = fertiProduct;
      }
    });
  }
  //If it doesn't exists-->create new phaseData for the current fertiProduct
  if (!currPhaseData) {
    const phaseData = new Object();
    phaseData.rowId = currRowIndex;
    phaseData.phase = (currRowIndex - 1) / productsForPhase + 1;

    //Find current period
    const [value, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(currRowIndex);

    let currPeriodValue;
    newPlan.fertiPlanData.forEach((phaseData) => {
      if (phaseData.rowId === minPhaseRow) {
        currPeriodValue = phaseData.period;
      }
    });
    phaseData.period = currPeriodValue;
    phaseData.fertiProduct = fertiProduct;
    newPlan.fertiPlanData.push(phaseData);
    console.log(newPlan.fertiPlanData);
  }
};*/

const updateFertiProductValue = function (
  currRow,
  currRowIndex,
  fertiProduct,
  productId,
) {
  const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(currRowIndex);

  //Check if phaseData exists for the current row
  const phaseDataIndex = newPlan.fertiPlanData.findIndex(
    (phaseData) => phaseData.rowId === currRowIndex,
  );
  console.log(phaseDataIndex);

  //If phaseData exists (so period exists) --> upload period in currRow and check product
  if (phaseDataIndex >= 0) {
    console.log("esiste phaseData");

    newPlan.fertiPlanData.forEach((phaseData) => {
      if (phaseData.rowId === currRowIndex) {
        /*
      console.log(minPhaseRow, maxPhaseRow, phaseData.period);
      let period;
      if (
        phaseData.rowId >= minPhaseRow &&
        phaseData.rowId <= maxPhaseRow &&
        phaseData.period
      ) {
        console.log(phaseData.period);
        period = phaseData.period;
        //}

        newPlan.fertiPlanData.forEach((phaseData) => {
          if (phaseData.rowId === currRowIndex) {
            phaseData.period = period;
          }
        });*/

        //If product exists-->check supply
        if (fertiProduct) {
          phaseData.product = fertiProduct;
          const selectProduct = currRow.querySelector(".uf-product-select");
          const productId =
            selectProduct.options[selectProduct.selectedIndex].dataset
              .productId;
          console.log(productId);
          phaseData.productId = productId;

          //If supply exists-->check intNum
          if (phaseData.supply) {
            calcSupplyData(phaseData, currRowIndex);
            //If intNum exists--> calc and check concPlant
            if (phaseData.intNum) {
              calcCurrProdSupply();
              calcTotPlanUf();
              calcTotCost(minPhaseRow, maxPhaseRow, phase);
              renderFertiTotCost(minPhaseRow, phase);
              calcTotSupply(minPhaseRow, maxPhaseRow, phase);
              //If concPlant exists-->update
              if (phaseData.concPlant) {
                calcConcData(
                  phase,
                  minPhaseRow,
                  maxPhaseRow,
                  currRowIndex,
                  currRow,
                );
              }
              //If concPlant doesnt exist-->nothing
            }
            //If intNum doesnt exist--> nothing
          }
          //If supply doesnt exist-->nothing
        }
        //If product deosnt exist-->check supply
        if (!fertiProduct) {
          updateEmptyFertiProduct(currRowIndex, currRow);

          newPlan.fertiPlanData.forEach((phaseData) => {
            if (phaseData.rowId === currRowIndex) {
              //If supply exists-->update and check intNum
              if (phaseData.supply) {
                updateEmptySupply(
                  currRow,
                  currRowIndex,
                  minPhaseRow,
                  maxPhaseRow,
                  phase,
                );

                //If intNum exists-->check if other phaseData exists for the same phase
                if (phaseData.intNum) {
                  console.log("intNum exists");
                  //Delete current phaseData
                  newPlan.fertiPlanData = newPlan.fertiPlanData.filter(
                    (phaseData) => phaseData.rowId !== currRowIndex,
                  );

                  //Find valid phaseData for the current phase
                  let countValidPhaseData = 0;
                  newPlan.fertiPlanData.forEach((phaseData) => {
                    if (
                      phaseData.rowId >= minPhaseRow &&
                      phaseData.rowId <= maxPhaseRow &&
                      phaseData.supply
                    ) {
                      countValidPhaseData++;
                    }
                  });
                  console.log(countValidPhaseData);

                  //If at least 1 other phaseData exists
                  if (countValidPhaseData >= 1) {
                    console.log("phaseData exist");

                    calcCurrProdSupply();
                    calcTotPlanUf();
                    calcTotCost(minPhaseRow, maxPhaseRow, phase);
                    renderFertiTotCost(minPhaseRow, phase);
                    calcTotSupply(minPhaseRow, maxPhaseRow, phase);

                    //If concPLant exists-->calc update

                    if (phaseData.concPlant) {
                      console.log("concPlant exists");
                      //Render empty single row values
                      currRow.querySelector(".calculated-cond").textContent =
                        "";
                      currRow.querySelector(".calculated-conc").textContent =
                        "";

                      calcConcData(
                        phase,
                        minPhaseRow,
                        maxPhaseRow,
                        currRowIndex,
                        currRow,
                      );
                    }
                    //If concPlant NOT exists-->nothing
                  }
                  //If other valid phaseData NOT exist-->nothing
                  if (countValidPhaseData < 1) {
                    console.log("another phaseData doesnt exist");

                    //Update fertiPanTotData
                    newPlan.fertiPlanTotData = newPlan.fertiPlanTotData.filter(
                      (phaseTotData) => phaseTotData.phase !== phase,
                    );

                    updateEmptyIntNum(
                      minPhaseRow,
                      maxPhaseRow,
                      phase,
                      newPlan.fertiPlanData,
                      currRow,
                    );
                    //Check if concPlant exists
                    //If concPlant exixts-->update
                    if (phaseData.concPlant) {
                      updateEmptyConcPlantData(minPhaseRow, maxPhaseRow, phase);
                    }
                    //If concPlant doesnt exist--> nothing
                  }
                  console.log(newPlan);

                  //If intNum doesnt exist--> nothing
                }
              }
              //If supply doesnt exist--> nothing
            }
          });
        }
      }
    });
  }

  //If phaseData doesnt exists--> check if period exists for the current phase

  if (phaseDataIndex < 0) {
    console.log("non esiste phaseData");
    let period;
    newPlan.fertiPlanData.forEach((phaseData) => {
      if (
        phaseData.rowId >= minPhaseRow &&
        phaseData.rowId <= maxPhaseRow &&
        phaseData.period
      ) {
        period = phaseData.period;
      }
    });
    console.log(period);
    //If period doesnt exist-->check if product exists
    if (!period) {
      //If product exists--> alert window
      if (fertiProduct) {
        console.log("esiste fertiProduct");
        renderEmptyDataAlertWindow(
          "Dati incompleti: compilare il campo Fase fenologica-Periodo, PRIMA di inserire il Prodotto.",
          newPlanTableWindow,
          "newPlan",
        );

        //Render empty supply value
        currRow.querySelector(".uf-product-select").value = "";
      }
      //If product doesnt exist--> nothing
    }
    //If period exists--> check product
    if (period) {
      console.log("period exists for the current phase");
      //If product exists-->update
      if (fertiProduct) {
        console.log("product exists");
        console.log(fertiProduct);

        const phaseData = new Object();

        phaseData.rowId = currRowIndex;
        phaseData.phase = phase;
        phaseData.period = period;
        phaseData.product = fertiProduct;
        console.log("fertiProduct :", fertiProduct);
        phaseData.productId = productId;
        console.log(phaseData);

        newPlan.fertiPlanData.push(phaseData);
      }
      //If product doesnt't exist-->nothing
    }
  }
  console.log(newPlan);
};

const updateEmptyFertiProduct = function (currRowIndex, currRow) {
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (phaseData.rowId === currRowIndex) {
      delete phaseData.product;
      delete phaseData.productId;
    }

    currRow.querySelector(".uf-product-select").value = "";
  });
};

const updateSupplyValue = function (supply, currRowIndex, currRow) {
  const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(currRowIndex);

  //Check if phaseData exists for the current row
  const phaseDataIndex = newPlan.fertiPlanData.findIndex(
    (phaseData) => phaseData.rowId === currRowIndex,
  );
  console.log(phaseDataIndex);

  //If phaseData exists --> check if product exists
  if (phaseDataIndex >= 0) {
    newPlan.fertiPlanData.forEach((phaseData) => {
      console.log("phaseData exists");
      console.log(phaseData.rowId, currRowIndex, phaseData.product, phaseData);
      //If product NOT exists-->render alert window
      if (phaseData.rowId === currRowIndex && !phaseData.product) {
        console.log("non esiste fertiProduct");
        renderEmptyDataAlertWindow(
          "Dati incompleti: compilare tutti i campi di Prodotto, PRIMA di inserire la Dose.",
          newPlanTableWindow,
          "newPlan",
        );

        //Render empty supply value
        currRow.querySelector(".supply").value = "";
      }
      //If product exists--> check supply value
      if (phaseData.rowId === currRowIndex && phaseData.product) {
        console.log("product exists");
        //If supply exists-->upload value and check intNum
        if (supply) {
          console.log("supply exists");
          phaseData.supply = supply;
          console.log(phaseData);
          console.log(newPlan);
          calcSupplyData(phaseData, currRowIndex);
          //If intNum exists-->calc update and check concPlant value

          let intNum;
          newPlan.fertiPlanData.forEach((phaseData) => {
            if (
              phaseData.rowId >= minPhaseRow &&
              phaseData.rowId <= maxPhaseRow
            ) {
              if (phaseData.intNum) intNum = phaseData.intNum;
            }
          });
          console.log(intNum);
          if (intNum) phaseData.intNum = intNum;

          if (phaseData.intNum) {
            console.log("intNum exists");
            phaseData.intNum = intNum;
            calcCurrProdSupply();
            calcTotPlanUf();
            calcTotCost(minPhaseRow, maxPhaseRow, phase);
            renderFertiTotCost(minPhaseRow, phase);
            calcTotSupply(minPhaseRow, maxPhaseRow, phase);
            //If concPLant exists-->calc update

            let concPlant;
            newPlan.fertiPlanData.forEach((phaseData) => {
              if (
                phaseData.rowId >= minPhaseRow &&
                phaseData.rowId <= maxPhaseRow
              ) {
                if (phaseData.concPlant) concPlant = phaseData.concPlant;
              }
            });
            console.log(concPlant);
            if (concPlant) phaseData.concPlant = concPlant;

            if (phaseData.concPlant) {
              console.log("concPlant exists");
              calcConcData(
                phase,
                minPhaseRow,
                maxPhaseRow,
                currRowIndex,
                currRow,
              );
            }
            //If concPlant NOT exists-->nothing
          }
          //If intNum NOT exists--> nothing
        }
        //If supply NOT exists-->delete value and check intNum
        if (!supply) {
          console.log("supply doesnt exist");

          updateEmptySupply(
            currRow,
            currRowIndex,
            minPhaseRow,
            maxPhaseRow,
            phase,
          );

          console.log(newPlan);

          //If intNum exists-->check if other phaseData exists
          if (phaseData.intNum) {
            console.log("intNum exists");

            console.log(currRowIndex);
            //Delete current phaseData
            newPlan.fertiPlanData = newPlan.fertiPlanData.filter(
              (phaseData) => phaseData.rowId !== currRowIndex,
            );
            //Render empty fertiProduct
            currRow.querySelector(".uf-product-select").value = "";

            console.log(newPlan);
            /*
            //Update empty intNum value
            fertiPlanData.forEach((phaseData) => {
              if (phaseData.rowId === currRowIndex) delete phaseData.intNum;
            });*/

            //Find valid phaseData for the current phase
            let countValidPhaseData = 0;
            newPlan.fertiPlanData.forEach((phaseData) => {
              if (
                phaseData.rowId >= minPhaseRow &&
                phaseData.rowId <= maxPhaseRow &&
                phaseData.supply
              ) {
                countValidPhaseData++;
              }
            });
            console.log(countValidPhaseData);

            //If at least 1 other phaseData exists
            if (countValidPhaseData >= 1) {
              console.log("phaseData exist");
              calcCurrProdSupply();
              calcTotPlanUf();
              calcTotCost(minPhaseRow, maxPhaseRow, phase);
              renderFertiTotCost(minPhaseRow, phase);
              calcTotSupply(minPhaseRow, maxPhaseRow, phase);

              //Check if concPlant exists
              //If concPlant exixts-->update
              if (phaseData.concPlant) {
                //Render empty concPlant data
                currRow.querySelector(".calculated-cond").textContent = "";
                currRow.querySelector(".calculated-conc").textContent = "";

                calcConcData(
                  phase,
                  minPhaseRow,
                  maxPhaseRow,
                  currRowIndex,
                  currRow,
                );
              }
              //If concPlant doesnt exist--> nothing
            }
            if (countValidPhaseData < 1) {
              console.log("another phaseData doesnt exist");

              //Update fertiPanTotData
              newPlan.fertiPlanTotData = newPlan.fertiPlanTotData.filter(
                (phaseTotData) => phaseTotData.phase !== phase,
              );

              updateEmptyIntNum(
                minPhaseRow,
                maxPhaseRow,
                phase,
                newPlan.fertiPlanData,
                currRow,
              );
              //Check if concPlant exists
              //If concPlant exixts-->update
              if (phaseData.concPlant) {
                updateEmptyConcPlantData(minPhaseRow, maxPhaseRow, phase);
              }
              //If concPlant doesnt exist--> nothing
            }
            console.log(newPlan);
          }
          //If intNum doesnt exist-->nothing
        }
      } /*
      //If product NOT exists-->render alert window
      if (phaseData.rowId === currRowIndex && !phaseData.fertiProduct) {
        console.log("non esiste fertiProduct");
        renderEmptyDataAlertWindow(
          "Dati incompleti: compilare tutti i campi di Prodotto, PRIMA di inserire la Dose."
        );

        //Render empty supply value
        currRow.querySelector(".supply").value = "";
      }*/
    });
  }
  //If phaseData NOT exists --> check supply value
  if (phaseDataIndex < 0) {
    //If supply exists--> render alert window
    if (supply) {
      renderEmptyDataAlertWindow(
        "Dati incompleti: compilare tutti i campi di Fase fenologica-Periodo e Prodotto, PRIMA di inserire la Dose.",
        newPlanTableWindow,
        "newPlan",
      );
      //Render empty supply value
      currRow.querySelector(".supply").value = "";
    }
    //If supply NOT exists--> nothing
  }
  console.log(newPlan);
};

const updateEmptySupply = function (
  currRow,
  currRowIndex,
  minPhaseRow,
  maxPhaseRow,
  phase,
) {
  //Render empty supply
  currRow.querySelector(".supply").value = "";

  //Update supply values
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (phaseData.rowId === currRowIndex) {
      delete phaseData.supply;
      delete phaseData.liquidProdVol;
    }
  });

  //Update
  //Find valid phaseData for the current phase
  let countValidPhaseData = 0;
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.supply
    ) {
      countValidPhaseData++;
    }
  });
  console.log(countValidPhaseData);

  //If at least 1 other phaseData exists
  if (countValidPhaseData >= 1) {
    console.log("other valid phaseData exist");
    updateLiquidProdTotVol(minPhaseRow, maxPhaseRow, phase);
  }
  if (countValidPhaseData < 1) {
    console.log("no other valid phaseData exist");
    newPlan.fertiPlanTotData.forEach((phaseTotData) => {
      if (phaseTotData.phase === phase) {
        delete phaseTotData.liquidProdTotVol;
      }
    });
  }
  console.log(newPlan);
};

const updateIntNumValue = function (intNum, currRowIndex, currRow) {
  console.log("update intNum value");

  const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(currRowIndex);
  //Check if phaseData for the current intNum already exists
  //Check if a phaseData with the same phase exists
  const currentPhase = (currRowIndex - 1) / productsForPhase + 1;

  let currentPhaseIndex = [];
  newPlan.fertiPlanData.forEach((data) => {
    if (data.phase === currentPhase && data.product) {
      currentPhaseIndex.push(data.rowId);
    }
  });

  //If phaseData exists-->check if supply exists
  if (currentPhaseIndex.length !== 0) {
    console.log("phaseData exists");

    //Check if supply exists for all valid rows
    let supplyExistsIndex = [];
    currentPhaseIndex.forEach((index) => {
      newPlan.fertiPlanData.forEach((phaseData) => {
        if (phaseData.rowId === index && phaseData.supply) {
          supplyExistsIndex.push(phaseData.rowId);
        }
      });
    });
    console.log(currentPhaseIndex, supplyExistsIndex);

    //Supply exists for all valid rows
    if (currentPhaseIndex.length === supplyExistsIndex.length) {
      //Check if intNum exists
      //If intNum exists
      if (intNum) {
        console.log("intNumExists");
        //Update intNum value in fertiPlanData
        currentPhaseIndex.forEach((index) => {
          newPlan.fertiPlanData.forEach((phaseData) => {
            if (phaseData.rowId === index) {
              phaseData.intNum = intNum;
              console.log(phaseData, newPlan.fertiPlanData);
            }
          });
        });

        //Update calculated values (includes render and upload)
        calcCurrProdSupply();
        calcTotPlanUf();
        calcTotCost(minPhaseRow, maxPhaseRow, phase);
        renderFertiTotCost(minPhaseRow, phase);
        calcTotSupply(minPhaseRow, maxPhaseRow, phase);
        console.log(newPlan);

        //Check if concPlant exists
        newPlan.fertiPlanData.forEach((phaseData) => {
          //If concPlant exists-->update
          if (
            phaseData.rowId >= minPhaseRow &&
            phaseData.rowId <= maxPhaseRow &&
            phaseData.concPlant
          ) {
            console.log("concPlantExists");
            calcConcData(
              phase,
              minPhaseRow,
              maxPhaseRow,
              currRowIndex,
              currRow,
            );
          }
          //If concPlant NOT exists-->nothing
        });
      }
      //If intNum NOT exists
      if (!intNum) {
        console.log("intNum not exists");

        updateEmptyIntNum(
          minPhaseRow,
          maxPhaseRow,
          phase,
          newPlan.fertiPlanData,
          currRow,
        );

        //CHECK IF concPlant EXISTS
        newPlan.fertiPlanData.forEach((phaseData) => {
          //If concPlant exists-->update
          if (
            phaseData.rowId >= minPhaseRow &&
            phaseData.rowId <= maxPhaseRow &&
            phaseData.concPlant
          ) {
            console.log("concPlantExists");

            updateEmptyConcPlantData(minPhaseRow, maxPhaseRow, phase);
          }
          //If concPlant NOT exists-->nothing
        });
      }
    }
    //Not supply for all valid rows
    if (currentPhaseIndex.length !== supplyExistsIndex.length) {
      renderEmptyDataAlertWindow(
        "Dati incompleti: compilare tutti i campi di Dose, PRIMA di inserire il Numero Interventi.",
        newPlanTableWindow,
        "newPlan",
      );

      //Render empty intNum value
      const supplyTable = document.querySelector(".supply-table");
      console.log(supplyTable);

      const multipleRow = supplyTable.rows[minPhaseRow];

      multipleRow.querySelector(".intNum").value = "";
    }
  }
  //If phaseData NOT exists-->check intNum value
  if (currentPhaseIndex.length === 0) {
    //If intNum exists--> render alert window
    if (intNum) {
      renderEmptyDataAlertWindow(
        "Dati incompleti: compilare tutti i campi di Fase fenologica-Periodo, Prodotto, Dose, PRIMA di inserire il Numero Interventi.",
        newPlanTableWindow,
        "newPlan",
      );

      //Render empty intNum value
      const supplyTable = document.querySelector(".supply-table");
      console.log(supplyTable);

      const multipleRow = supplyTable.rows[minPhaseRow];

      multipleRow.querySelector(".intNum").value = "";
      console.log(newPlan);
    }
    //If intNum exists-->nothing
  }
  console.log(newPlan);
};

const calcTotSupply = function (minPhaseRow, maxPhaseRow, phase) {
  let totSupplyHa = 0;
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.intNum
    ) {
      totSupplyHa = totSupplyHa + Number(phaseData.supply);
    }
  });
  console.log(totSupplyHa);

  const totSupplySector = totSupplyHa * newPlan.sectorAreaHa;
  console.log(totSupplySector);

  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.phase === phase)
      phaseTotData.totSupplySector = totSupplySector;
  });
  console.log(newPlan);
};

const updateEmptyConcPlantData = function (minPhaseRow, maxPhaseRow, phase) {
  /*
  //Remove concPlant from fertiPlanData
  fertiPlanData.forEach((phaseData) => {
    if (phaseData.rowId >= minPhaseRow && phaseData.rowId <= maxPhaseRow){
      delete phaseData.concPlant;
      delete phaseData.conductivity;
      delete phaseData.concProdInt;
      delete phaseData.realCond;
    }
  });
  console.log(fertiPlanData);*/
  /*
  //Render empty concPlant
  const supplyTable = document.querySelector(".supply-table");
  console.log(supplyTable);

  const multipleRow = supplyTable.rows[minPhaseRow];

  multipleRow.querySelector(".concPlant").value = "";
  */

  renderEmptyConcPlantData(minPhaseRow, maxPhaseRow);

  removeConcPlantData(phase, minPhaseRow, maxPhaseRow);
};

const updateEmptyIntNum = function (
  minPhaseRow,
  maxPhaseRow,
  phase,
  fertiPlanData,
  currRow,
) {
  //Remove values from fertiPlanData and fertiPlanTotData
  removeIntNumData(phase, minPhaseRow, maxPhaseRow);
  console.log(newPlan);

  //UPDATE FERTIPLANTABLE
  //Render empty values
  console.log(currRow);

  //Find multiple cell row
  const supplyTable = document.querySelector(".supply-table");
  console.log(supplyTable);

  const multipleRow = supplyTable.rows[minPhaseRow];

  multipleRow.querySelector(".intNum").value = "";

  const totCostHa = "";
  const totCostSector = "";

  renderIntNumData(minPhaseRow, maxPhaseRow, totCostHa, totCostSector);

  //UPDATE TOT SUPPLYTABLE - update values and render new table
  calcTotPlanUf();
};

const renderIntNumData = function (
  minPhaseRow,
  maxPhaseRow,
  totCostHa,
  totCostSector,
) {
  //RENDER FERTI PLAN TABLE DATA
  //Find multiple cell row
  const supplyTable = document.querySelector(".supply-table");
  console.log(supplyTable);

  const multipleRow = supplyTable.rows[minPhaseRow];

  multipleRow.querySelector(".calculated-cost-ha").textContent = totCostHa;
  multipleRow.querySelector(".calculated-cost-sector").textContent =
    totCostSector;

  //RENDER TOT SUPPLY DATA
  calcCurrProdSupply();
  calcTotPlanUf();
};

const removeIntNumData = function (phase, minPhaseRow, maxPhaseRow) {
  //Remove data from fertiPlanData
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (phaseData.rowId >= minPhaseRow && phaseData.rowId <= maxPhaseRow) {
      delete phaseData.intNum;
      delete phaseData.costHa;
      delete phaseData.costSector;
      delete phaseData.countEurokg;
      delete phaseData.currProdSupply;
      delete phaseData.currProdTotSupply;
    }
  });
  //Remove from fertiPlanTotData
  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.phase === phase) {
      delete phaseTotData.totCostHa;
      delete phaseTotData.totCostSector;
      delete phaseTotData.totSupplySector;
    }
  });
  console.log(newPlan);
};

const updateConcPlantValue = function (currRow, currRowIndex, concPlant) {
  console.log("update concPlant value");
  //Check if phaseData for the current concPlant already exists
  //Check if a phaseData with the same phase exists
  console.log(currRowIndex);
  const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(currRowIndex);

  const currentPhase = (currRowIndex - 1) / productsForPhase + 1;

  let currentPhaseIndex = [];
  newPlan.fertiPlanData.forEach((data) => {
    if (data.phase === currentPhase && data.supply) {
      currentPhaseIndex.push(data.rowId);
    }
  });
  console.log(currentPhase, currentPhaseIndex);
  console.log(concPlant);

  //If phaseData exists-->check if intNum exists
  if (currentPhaseIndex.length !== 0) {
    console.log("phaseData exists");
    //Check if intNum exists for all valid rows
    let intNumExistsIndex = [];
    currentPhaseIndex.forEach((index) => {
      newPlan.fertiPlanData.forEach((phaseData) => {
        if (phaseData.rowId === index && phaseData.intNum) {
          intNumExistsIndex.push(phaseData.rowId);
        }
      });
    });
    console.log(currentPhaseIndex, intNumExistsIndex);

    //IntNum exists for all valid rows
    if (currentPhaseIndex.length === intNumExistsIndex.length) {
      //Check if concPlant exists
      //If concPlant exists
      if (concPlant) {
        console.log("concPlantExists");
        //Update concPlant value in fertiPlanData
        intNumExistsIndex.forEach((index) => {
          newPlan.fertiPlanData.forEach((phaseData) => {
            if (phaseData.rowId === index) {
              phaseData.concPlant = concPlant;
              //Update calculated values
              calcConcData(phase, minPhaseRow, maxPhaseRow, index, currRow);
            }
          });
        });

        console.log(newPlan);
      }
      //If concPlant NOT exists
      if (!concPlant) {
        console.log("concPLant not exists");

        updateEmptyConcPlantData(minPhaseRow, maxPhaseRow, phase);
      }
    }
    //If IntNum NOT exists for all valid rows
    if (currentPhaseIndex.length !== intNumExistsIndex.length) {
      renderEmptyDataAlertWindow(
        "Dati incompleti: compilare tutti i campi di Numero Interventi, PRIMA di inserire la Concentrazione sulla Pianta.",
        newPlanTableWindow,
        "newPlan",
      );

      //Render empty concPlant value
      const supplyTable = document.querySelector(".supply-table");
      console.log(supplyTable);

      const multipleRow = supplyTable.rows[minPhaseRow];

      multipleRow.querySelector(".concPlant").value = "";
    }
  }

  //If phaseData doesn't exists-->check concPlant value

  if (currentPhaseIndex.length === 0) {
    console.log("phaseData NOT exists");

    //If concPlant exists-->alert window and render empty concPlantValue
    if (concPlant) {
      renderEmptyDataAlertWindow(
        "Dati incompleti: compilare tutti i campi di Fase fenologica-Periodo, Prodotto, Dose, Numero Interventi, PRIMA di inserire la Concentrazione sulla Pianta.",
        newPlanTableWindow,
        "newPlan",
      );

      //Render empty concPlant value
      const supplyTable = document.querySelector(".supply-table");
      console.log(supplyTable);

      const multipleRow = supplyTable.rows[minPhaseRow];

      multipleRow.querySelector(".concPlant").value = "";
      console.log(newPlan);
    }
    //If concPlant NOT exists--> nothing
  }
  console.log(newPlan);
};

const removeConcPlantData = function (phase, minPhaseRow, maxPhaseRow) {
  //Remove data from fertiPlanData
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (phaseData.rowId >= minPhaseRow && phaseData.rowId <= maxPhaseRow) {
      delete phaseData.concPlant;
      delete phaseData.concProdInt;
      delete phaseData.realCond;
      delete phaseData.conductivity;
    }
  });
  console.log(newPlan.fertiPlanData);

  //Remove data from fertiPlanTotData
  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.phase === phase) {
      delete phaseTotData.finalConc;
      delete phaseTotData.motherSolVol;
      delete phaseTotData.waterVol;
      delete phaseTotData.coeffSolubPhase;
      delete phaseTotData.maxFertiTime;
      delete phaseTotData.maxWaterVolHa;
      delete phaseTotData.maxWaterVolSector;
      delete phaseTotData.totIrrigatTime;
      delete phaseTotData.totWaterVolSector;
      delete phaseTotData.waterSupplyMmHa;
      delete phaseTotData.waterSupplyPeriodMmHa;

      console.log(newPlan.fertiPlanTotData);
    }
  });
};

const renderCheckConfirmWindow = function (msg, [type, currRowIndex, currRow]) {
  console.log(emptyDataHeading);
  confirmActionHeading.textContent = "";
  confirmActionHeading.textContent = msg;

  confirmActionWindow.classList.remove("hidden");

  lockEventListenersTable([newPlanNav, menuTag, newPlanTableWindow]);

  //Modal Btn
  checkModalCloseBtn(
    confirmActionModalBtn,
    confirmActionWindow,
    [newPlanNav, newPlanTableWindow],
    [currRowIndex, currRow],
  );

  //Close btn
  checkModalCloseBtn(
    confirmActionNotBtn,
    confirmActionWindow,
    [newPlanNav, newPlanTableWindow],
    [currRowIndex, currRow],
  );

  //Confirm btn
  checkConfirmActionBtn(
    confirmActionBtn,
    confirmActionWindow,
    [newPlanNav, newPlanTableWindow],
    [type, currRowIndex],
  );
};

const checkModalCloseBtn = function (
  btn,
  window,
  unlockEl,
  [currRowIndex, currRow],
) {
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    window.classList.add("hidden");
    unlockEventListenersTable(unlockEl);
    //Set value
    let currValue = 0;
    newPlan.fertiPlanData.forEach((phaseData) => {
      if (phaseData.rowId === currRowIndex) {
        console.log(phaseData.period);
        currValue = phaseData.period;
      }
    });
    const currCellPeriod = currRow.querySelector(".period");
    currCellPeriod.value = currValue;
    console.log(currCellPeriod);
  });
};

const checkConfirmActionBtn = function (
  confirmActionBtn,
  confirmActionWindow,
  elArray,
  [type, currRowIndex],
) {
  confirmActionBtn.addEventListener("click", function () {
    console.log("action confirmed");
    //Hide window
    confirmActionWindow.classList.add("hidden");

    //UNlock menu
    unlockEventListenersTable(elArray);

    //Update fertiPlanData
    const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(currRowIndex);
    console.log(newPlan.fertiPlanData);
    if (type === "deletePhaseDataObj") {
      console.log("delete phase data for the period");
      console.log(phase, minPhaseRow, maxPhaseRow);
      let rowsIdToRemove = [];
      newPlan.fertiPlanData.forEach((phaseData) => {
        console.log(phaseData);
        if (phaseData.rowId >= minPhaseRow && phaseData.rowId <= maxPhaseRow) {
          console.log(phaseData);
          rowsIdToRemove.push(phaseData.rowId);
        }

        console.log(newPlan.fertiPlanData);
      });

      removePhaseData(rowsIdToRemove);

      //Remove phaseTotData
      let removingPhase;
      newPlan.fertiPlanTotData.forEach((phaseTotData) => {
        if (phaseTotData.phase === phase) {
          removePhaseTotData(phase);
          removingPhase = phase;
        }
      });

      //replaceRemovedPhase(removingPhase);

      //updateDataTable();

      //Render empty values for the phase
      //Mutiple row
      const supplyTable = document.querySelector(".supply-table");

      const multipleRow = supplyTable.rows[minPhaseRow];

      multipleRow.querySelector(".period").value = "";
      multipleRow.querySelector(".intNum").value = "";
      multipleRow.querySelector(".concPlant").value = "";
      multipleRow.querySelector(".calculated-mother-volume").textContent = "";
      multipleRow.querySelector(".calculated-cost-ha").textContent = "";
      multipleRow.querySelector(".calculated-cost-sector").textContent = "";
      //Single row
      for (let i = minPhaseRow; i <= maxPhaseRow; i++) {
        const currRow = supplyTable.rows[i];
        currRow.querySelector(".uf-product-select").value = "";
        currRow.querySelector(".supply").value = "";
        currRow.querySelector(".calculated-cond").textContent = "";
        currRow.querySelector(".calculated-conc").textContent = "";
      }
      calcTotPlanUf();
    }
    console.log(newPlan);
  });
};

const removePhaseData = function (rowsIdToRemove) {
  newPlan.fertiPlanData = newPlan.fertiPlanData.filter(
    (phaseData) => !rowsIdToRemove.includes(phaseData.rowId),
  );

  console.log(newPlan);
};

const replaceRemovedPhase = function (removingPhase) {
  console.log("scalare le fasi per non avere vuoti");
  console.log(newPlan.fertiPlanData);

  console.log(removingPhase);

  newPlan.fertiPlanData.forEach((phaseData) => {
    if (phaseData.phase > removingPhase) {
      phaseData.phase = phaseData.phase - 1;
      phaseData.rowId = phaseData.rowId - productsForPhase;
    }
  });
  console.log(newPlan.fertiPlanData);
  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.phase > removingPhase) {
      phaseTotData.phase = phaseTotData.phase - 1;
    }
  });
  console.log(newPlan.fertiPlanTotData);
};

const getMinMaxPhaseRow = function (currRowIndex) {
  const phase = Math.trunc((currRowIndex - 1) / productsForPhase + 1);
  console.log(currRowIndex);

  const minPhaseRow = (phase - 1) * productsForPhase + 1;
  const maxPhaseRow =
    (phase - 1) * productsForPhase + 1 + (productsForPhase - 1);
  console.log(minPhaseRow, maxPhaseRow);
  return [phase, minPhaseRow, maxPhaseRow];
};

const updateDataTable = function () {
  //Delete fertitable
  fertiTableWindow.innerHTML = "";

  //Render empty fertiTable
  renderFertiPlanTable();
  //Render fertitable values from fertiPlanData+fertiPlanTotData
  console.log(newPlan.fertiPlanData, newPlan.fertiPlanTotData);
  renderFertiValues();

  //Update tot Supply Table
  updateTotSupplyTable(newPlan.fertiPlanData);
  //Check ferti table Data
  checkFertiTableData();
};

const renderFertiValues = function () {
  const supplyTable = document.querySelector(".supply-table");

  console.log(supplyTable.rows[1].querySelector(".period"));
  console.log(supplyTable.rows[1].querySelector(".supply"));

  newPlan.fertiPlanData.forEach((phaseData) => {
    console.log(phaseData.phase);
    const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(
      phaseData.rowId,
    );
    //Render rows with multiple cells
    if (phaseData.rowId === minPhaseRow) {
      supplyTable.rows[phaseData.rowId].querySelector(".period").value =
        phaseData.period;
      supplyTable.rows[phaseData.rowId].querySelector(
        ".uf-product-select",
      ).value = phaseData.fertiProduct;
      supplyTable.rows[phaseData.rowId].querySelector(".supply").value =
        phaseData.supply;
      supplyTable.rows[phaseData.rowId].querySelector(".intNum").value =
        phaseData.intNum;
      supplyTable.rows[phaseData.rowId].querySelector(".concPlant").value =
        phaseData.concPlant;
      supplyTable.rows[phaseData.rowId].querySelector(
        ".calculated-conc",
      ).textContent = phaseData.concProdInt;
      supplyTable.rows[phaseData.rowId].querySelector(
        ".calculated-cond",
      ).textContent = phaseData.condReal;
    }
    //Render rows without multiple cells
    if (phaseData.rowId !== minPhaseRow) {
      supplyTable.rows[phaseData.rowId].querySelector(
        ".uf-product-select",
      ).value = phaseData.fertiProduct;
      supplyTable.rows[phaseData.rowId].querySelector(".supply").value =
        phaseData.supply;
      supplyTable.rows[phaseData.rowId].querySelector(
        ".calculated-conc",
      ).textContent = phaseData.concProdInt;
      supplyTable.rows[phaseData.rowId].querySelector(
        ".calculated-cond",
      ).textContent = phaseData.condReal;
    }
  });
  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    const minPhaseRow = (phaseTotData.phase - 1) * productsForPhase + 1;
    supplyTable.rows[minPhaseRow].querySelector(
      ".calculated-mother-volume",
    ).textContent = phaseTotData.motherSolVol;
    supplyTable.rows[minPhaseRow].querySelector(
      ".calculated-cost-ha",
    ).textContent = phaseTotData.totCostHa;
    supplyTable.rows[minPhaseRow].querySelector(
      ".calculated-cost-sector",
    ).textContent = phaseTotData.totCostSector;
  });
};

const updateTotSupplyTable = function (fertiPlanData) {
  calcCurrProdSupply();
  calcTotPlanUf();
};

const updateTotSupply = function (minPhaseRow, maxPhaseRow, phase, rowIndex) {
  //Update tot supply for the current Phase
  let totSupplyHaPhase = 0;
  //let totSupplySectorPhase = 0;

  newPlan.fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.supply
    )
      totSupplyHaPhase = totSupplyHaPhase + Number(phaseData.supply);
    console.log(totSupplyHaPhase);
  });

  //const totSupplySectorPhase = totSupplyHaPhase*newPlan.sectorAreaHa;
  //console.log(totSupplySectorPhase);

  const existsTotPhaseData = newPlan.fertiPlanTotData.some(
    (phaseTotData) => phaseTotData.phase === phase,
  );
  console.log(existsTotPhaseData);
  if (existsTotPhaseData) {
    newPlan.fertiPlanTotData.forEach((phaseTotData) => {
      if (phaseTotData.phase === phase) {
        phaseTotData.totSupplyHa = totSupplyHaPhase.toFixed(1);
        phaseTotData.totSupplySector = (
          totSupplyHaPhase * newPlan.sectorAreaHa
        ).toFixed(1);
        console.log(newPlan.fertiPlanTotData);
      }
    });
  }
  if (!existsTotPhaseData) {
    const phaseTotData = new Object();
    phaseTotData.phase = phase;
    phaseTotData.totSupplyHa = totSupplyHaPhase;
    phaseTotData.totSupplySector = totSupplyHaPhase * newPlan.sectorAreaHa;
    newPlan.fertiPlanTotData.push(phaseTotData);
    console.log(newPlan.fertiPlanTotData);
  }
};

const calcSupplyData = function (phaseData, rowIndex) {
  const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(rowIndex);
  //Calc liquidProdVol
  const currFertiProductId = phaseData.productId;
  console.log(phaseData);
  console.log(currFertiProductId);
  console.log(originalFertiProductRows);
  let specificWeight = 0;
  let solubilCoeff = 0;
  originalFertiProductRows.forEach((product) => {
    if (product.productId === currFertiProductId) {
      specificWeight = product.specificWeightKgl;
      solubilCoeff = product.solubilCoeff;
    }
  });
  console.log(specificWeight, solubilCoeff, phaseData.supply);
  let liquidProdVol = 0;
  //Liquid fertiProduct
  if (solubilCoeff === 1) {
    console.log("solubilCoeff === 1");
    liquidProdVol = Number(
      (phaseData.supply / specificWeight) * newPlan.sectorAreaHa,
    ).toFixed(1);
    console.log(liquidProdVol);
  }
  //Solid fertiProduct
  if (solubilCoeff < 1) {
    console.log("solubilCoeff < 1");
    liquidProdVol = Number(
      phaseData.supply * solubilCoeff * newPlan.sectorAreaHa,
    ).toFixed(1);
    console.log(liquidProdVol);
  }
  console.log(liquidProdVol);

  newPlan.fertiPlanData.forEach((phaseData) => {
    if (phaseData.rowId === rowIndex) {
      phaseData.liquidProdVol = +liquidProdVol;
      console.log(newPlan.fertiPlanData);
    }
  });

  updateLiquidProdTotVol(minPhaseRow, maxPhaseRow, phase);

  /*let liquidProdTotVol = 0;
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.liquidProdVol
    ) {
      liquidProdTotVol = liquidProdTotVol + phaseData.liquidProdVol;
    }
  });
  console.log(liquidProdTotVol);*/
  //console.log(newPlan);
  /*
  //Calc totSupplyHa
  let totSupplyHa = 0;
  fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.supply
    )
      totSupplyHa = totSupplyHa + Number(phaseData.supply);
  });
  console.log(totSupplyHa);

  //Calc totSupplySector
  const totSupplySector = totSupplyHa * newPlan.sectorAreaHa;
  console.log(totSupplySector);*/
  /*
  //Upload new data
  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.phase === phase) {
      phaseTotData.liquidProdTotVol = liquidProdTotVol;
      //phaseTotData.totSupplyHa = totSupplyHa;
      //phaseTotData.totSupplySector = totSupplySector;
    }

    console.log(newPlan.fertiPlanTotData);
  });
  if (
    !newPlan.fertiPlanTotData.some(
      (phaseTotData) => phaseTotData.phase === phase
    )
  ) {
    console.log("non esiste phaseTotData per la fase corrente");
    const phaseTotData = new Object();
    phaseTotData.phase = phase;
    phaseTotData.liquidProdTotVol = liquidProdTotVol;
    //phaseTotData.totSupplyHa = totSupplyHa;
    //phaseTotData.totSupplySector = totSupplySector;
    newPlan.fertiPlanTotData.push(phaseTotData);
    console.log(newPlan.fertiPlanTotData);
  }
  console.log(newPlan);*/
};

const updateLiquidProdTotVol = function (minPhaseRow, maxPhaseRow, phase) {
  let liquidProdTotVol = 0;
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.liquidProdVol
    ) {
      liquidProdTotVol = liquidProdTotVol + phaseData.liquidProdVol;
    }
  });
  console.log(liquidProdTotVol);

  //Upload new data
  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.phase === phase) {
      phaseTotData.liquidProdTotVol = liquidProdTotVol;
    }
  });
  if (
    !newPlan.fertiPlanTotData.some(
      (phaseTotData) => phaseTotData.phase === phase,
    )
  ) {
    console.log("non esiste phaseTotData per la fase corrente");
    const phaseTotData = new Object();
    phaseTotData.phase = phase;
    phaseTotData.liquidProdTotVol = liquidProdTotVol;

    newPlan.fertiPlanTotData.push(phaseTotData);
  }

  console.log(newPlan);
};

const updateSupplyRow = function (
  phaseData,
  currPeriodRowIndex,
  rowIndex,
  currRow,
) {
  console.log("period fertiprod and supply exist");
  const [phase, minPhaseRow, maxPhaseRow] =
    getMinMaxPhaseRow(currPeriodRowIndex);
  console.log(minPhaseRow, maxPhaseRow, phase);
  updateTotSupply(minPhaseRow, maxPhaseRow, phase);
  calcSupplyData(phaseData, rowIndex);

  updateIntNumRow(currPeriodRowIndex, currRow);
};
/*
const updateIntNumRow = function (rowIndex, currRow) {
  const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(rowIndex);

  let currIntNum = 0;
  fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.intNum
    )
      currIntNum = phaseData.intNum;
  });
  console.log(currIntNum);

  if (currIntNum === 0) return;

  if (currIntNum !== 0) {
    console.log("period fertiprod supply  and IntNum exist");
    console.log(rowIndex);
    fertiPlanData.forEach((phaseData) => {
      if (phaseData.rowId === rowIndex) {
        phaseData.intNum = currIntNum;
        calcCurrProdSupply(fertiPlanData);
        calcTotPlanUf(fertiPlanData);
        updateConcRow(rowIndex, currRow);
      }
    });
  }
};*/

const calcConcData = function (
  phase,
  minPhaseRow,
  maxPhaseRow,
  currRowIndex,
  currRow,
) {
  console.log(currRow);
  //Find concPlant, intNum, totSupplySetor and liquidProdTotVol for the current phase, fertiFlowRate for the current sector and conductivity for each product of the phase
  let concPlant = 0;
  let intNum = 0;

  newPlan.fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.concPlant
    ) {
      concPlant = phaseData.concPlant;
      intNum = phaseData.intNum;

      //Find conductivity for each product
      let conductivity;
      originalFertiProductRows.forEach((prod) => {
        if (prod.productId === phaseData.productId) {
          conductivity = prod.conductivity;
        }
      });
      console.log(conductivity);
      phaseData.conductivity = conductivity;
    }
  });
  console.log(concPlant);
  console.log(newPlan);
  let totSupplySector = 0;
  let liquidProdTotVol = 0;
  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.phase === phase) {
      totSupplySector = phaseTotData.totSupplySector;
      liquidProdTotVol = phaseTotData.liquidProdTotVol;
    }
  });
  console.log(totSupplySector);
  console.log(liquidProdTotVol);
  let fertiFlowRate = 0;
  console.log(originalSectorRows);
  originalSectorRows.forEach((sector) => {
    console.log(sector.sectorId, newPlan.sectorId, sector.fertiFlowRate);
    if (sector.sectorId === newPlan.sectorId) {
      fertiFlowRate = sector.fertiFlowRate;
      console.log(fertiFlowRate);
    }
  });
  console.log(fertiFlowRate);

  //Calc. concPlant data
  const finalConc = (
    (((newPlan.sectorFlowRate * 1000) / fertiFlowRate) * concPlant) /
    10
  ).toFixed(1);
  console.log(finalConc);

  const motherSolVol = ((totSupplySector * 100) / finalConc).toFixed(4);
  console.log(motherSolVol);

  /*let finalConc = 0;
  let motherSolVol = 0;
  newPlan.fertiPlanData.forEach((phaseData) => {
    console.log(phaseData, phaseData.rowId, currRowIndex);
    if (phaseData.rowId === currRowIndex) {
      console.log(newPlan.sectorFlowRate, fertiFlowRate);
      finalConc = (
        (((newPlan.sectorFlowRate * 1000) / fertiFlowRate) *
          phaseData.concPlant) /
        10
      ).toFixed(1);
      console.log(finalConc);
      motherSolVol = ((totSupplySector * 100) / finalConc).toFixed(1);
      console.log(motherSolVol);
    }
  });*/
  /*
  let liquidProdTotVol = 0;
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.intNum
    ) {
      liquidProdTotVol = liquidProdTotVol + phaseData.liquidProdVol;
    }
  });
  console.log(liquidProdTotVol);*/
  const waterVol = motherSolVol - liquidProdTotVol;
  console.log(waterVol, motherSolVol, liquidProdTotVol);

  const coeffSolubPhase = ((totSupplySector / waterVol) * 100).toFixed(1);
  console.log(coeffSolubPhase);
  /*
  let coeffSolubPhase = 0;

  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.phase === phase) {
      console.log(phaseTotData, phaseTotData.totSupplySector, waterVol);
      coeffSolubPhase = (
        (phaseTotData.totSupplySector / waterVol) *
        100
      ).toFixed(1);
      console.log(coeffSolubPhase);
    }
  });*/

  const maxFertiTime = ((motherSolVol / fertiFlowRate) * 60).toFixed();

  const maxWaterVolHa = (
    (newPlan.irrigationRatePerHaM3 / 60) *
    maxFertiTime
  ).toFixed(1);

  const maxWaterVolSector = (
    (newPlan.sectorFlowRate / 60) *
    maxFertiTime
  ).toFixed(1);

  const totIrrigatTime = (
    +maxFertiTime +
    newPlan.totPressionTime +
    newPlan.emptyCleanTime
  ).toFixed();
  console.log(
    totIrrigatTime,
    maxFertiTime,
    newPlan.totPressionTime,
    newPlan.emptyCleanTime,
  );

  const totWaterVolSector = (
    (newPlan.sectorFlowRate / 60) *
    totIrrigatTime
  ).toFixed(1);

  console.log(newPlan.irrigationRatePerHaMm, totIrrigatTime);
  const waterSupplyMmHa = (
    (newPlan.irrigationRatePerHaMm / 60) *
    totIrrigatTime
  ).toFixed(1);
  console.log(waterSupplyMmHa);
  /*
  let intNum = 0;
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (phaseData.rowId === currRowIndex) {
      intNum = phaseData.intNum;
    }
  });*/
  const waterSupplyPeriodMmHa = (waterSupplyMmHa * intNum).toFixed(1);
  console.log(waterSupplyPeriodMmHa);
  /*
  let waterSupplyPeriodMmHa = 0;
  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.phase === phase) {
      console.log(phaseTotData.phase, phase, waterSupplyMmHa, intNum);
      waterSupplyPeriodMmHa = (waterSupplyMmHa * intNum).toFixed(1);
      console.log(waterSupplyPeriodMmHa);
    }
  });*/
  /*
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.intNum
    ) {
      let conductivity;
      originalFertiProductRows.forEach((prod) => {
        if (prod.productId === phaseData.productId) {
          conductivity = prod.conductivity;
        }
      });
      console.log(conductivity);
      phaseData.conductivity = conductivity;
    }
  });*/

  newPlan.fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.intNum
    ) {
      const concProdInt = (
        ((phaseData.supply * newPlan.sectorAreaHa) / waterVol) *
        100
      ).toFixed(2);
      console.log(phaseData.supply, newPlan.sectorAreaHa, waterVol);
      const realCond = (
        ((phaseData.concPlant * concProdInt) / finalConc) *
        phaseData.conductivity
      ).toFixed(1);
      console.log(concProdInt);
      phaseData.concProdInt = concProdInt;
      phaseData.realCond = realCond;
    }
  });

  console.log(
    newPlan,
    finalConc,
    motherSolVol,
    waterVol,
    maxFertiTime,
    maxWaterVolHa,
    totIrrigatTime,
    totWaterVolSector,
    waterSupplyMmHa,
  );

  //Render concPlant new data in supplyTable
  renderConcPlantData(minPhaseRow, maxPhaseRow, motherSolVol);

  //Upload concPlant new data in fertiPlanData and fertiPlanTotData
  uploadConcPlantData(
    phase,
    finalConc,
    motherSolVol,
    waterVol,
    coeffSolubPhase,
    maxFertiTime,
    maxWaterVolHa,
    maxWaterVolSector,
    totIrrigatTime,
    totWaterVolSector,
    waterSupplyMmHa,
    waterSupplyPeriodMmHa,
  );
};

const renderConcPlantData = function (minPhaseRow, maxPhaseRow, motherSolVol) {
  //Find multiple cell row

  const supplyTable = document.querySelector(".supply-table");
  console.log(supplyTable);

  const multipleRow = supplyTable.rows[minPhaseRow];

  multipleRow.querySelector(".calculated-mother-volume").textContent =
    motherSolVol;

  newPlan.fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.intNum
    ) {
      supplyTable.rows[phaseData.rowId].querySelector(
        ".calculated-conc",
      ).textContent = phaseData.concProdInt;
      supplyTable.rows[phaseData.rowId].querySelector(
        ".calculated-cond",
      ).textContent = phaseData.realCond;
    }
  });
};

const renderEmptyConcPlantData = function (minPhaseRow, maxPhaseRow) {
  //Find multiple cell row
  const supplyTable = document.querySelector(".supply-table");
  console.log(supplyTable);

  const multipleRow = supplyTable.rows[minPhaseRow];

  //Render empty multipleRow values
  multipleRow.querySelector(".concPlant").value = "";
  multipleRow.querySelector(".calculated-mother-volume").textContent = "";

  //Render empty single row values
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (phaseData.rowId >= minPhaseRow && phaseData.rowId <= maxPhaseRow) {
      supplyTable.rows[phaseData.rowId].querySelector(
        ".calculated-conc",
      ).textContent = "";
      supplyTable.rows[phaseData.rowId].querySelector(
        ".calculated-cond",
      ).textContent = "";
    }
  });
  if (newPlan.fertiPlanData === "") {
    console.log("empty fertiplandata");
    for (i = minPhaseRow; i <= maxPhaseRow; i++) {
      supplyTable.rows[i].querySelector(".calculated-conc").textContent = "";
      supplyTable.rows[i].querySelector(".calculated-cond").textContent = "";
    }
  }
};

const uploadConcPlantData = function (
  phase,
  finalConc,
  motherSolVol,
  waterVol,
  coeffSolubPhase,
  maxFertiTime,
  maxWaterVolHa,
  maxWaterVolSector,
  totIrrigatTime,
  totWaterVolSector,
  waterSupplyMmHa,
  waterSupplyPeriodMmHa,
) {
  //Upload calculated Data in fertiPlanTotData
  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.phase === phase) {
      phaseTotData.finalConc = finalConc;
      phaseTotData.motherSolVol = motherSolVol;
      phaseTotData.waterVol = waterVol;
      phaseTotData.coeffSolubPhase = coeffSolubPhase;
      phaseTotData.maxFertiTime = maxFertiTime;
      phaseTotData.maxWaterVolHa = maxWaterVolHa;
      phaseTotData.maxWaterVolSector = maxWaterVolSector;
      phaseTotData.totIrrigatTime = totIrrigatTime;
      phaseTotData.totWaterVolSector = totWaterVolSector;
      phaseTotData.waterSupplyMmHa = waterSupplyMmHa;
      phaseTotData.waterSupplyPeriodMmHa = waterSupplyPeriodMmHa;

      console.log(newPlan.fertiPlanTotData);
    }
  });
};

const updateConcRow = function (rowIndex, currRow) {
  const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(rowIndex);
  let currConcPlant = 0;
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.concPlant
    )
      currConcPlant = phaseData.concPlant;
  });
  console.log(currConcPlant);
  if (currConcPlant !== 0) {
    newPlan.fertiPlanData.forEach((phaseData) => {
      if (phaseData.rowId === rowIndex) {
        phaseData.concPlant = currConcPlant;
        console.log("period fertiprod supply IntNum and conc exist");
        console.log(currRow);
        calcConcData(phase, minPhaseRow, maxPhaseRow, rowIndex, currRow);
      }
    });
  }
};

const createSelectProduct = function (product) {
  let originalProduct;
  if (product === "product") {
    originalProduct = originalProductRows;
    const optionsS = originalProduct.map((r) => ({
      id: r.productId,
      text: `${r.product} - ${r.countN}.${r.countP2O5}.${r.countK2O}.${r.countCaO}.${r.countMgO}.${r.countSO3}`,
    }));

    const selectProduct = document.querySelectorAll(".basic-product-select");

    selectProduct.forEach((singleSelect) => {
      optionsS.forEach((option) => {
        let element = document.createElement("option");
        element.textContent = option.text;
        element.value = option.text;
        element.dataset.productId = option.id;
        singleSelect.appendChild(element);
      });
    });
  }
  if (product === "fertiProduct") {
    originalProduct = originalFertiProductRows;
    const optionsS = originalProduct.map((r) => ({
      id: r.productId,
      text: `${r.product} - ${r.countN}.${r.countP2O5}.${r.countK2O}.${r.countCaO}.${r.countMgO}.${r.countSO3}`,
    }));

    const selectProduct = document.querySelectorAll(".uf-product-select");

    selectProduct.forEach((singleSelect) => {
      optionsS.forEach((option) => {
        let element = document.createElement("option");
        element.textContent = option.text;
        element.value = option.text;
        element.dataset.productId = option.id;
        singleSelect.appendChild(element);
      });
    });
  }
};

const createSectorData = function () {
  const selectedSectorRow = findSelectedSector(
    originalSectorRows,
    newPlan.sectorId,
  );

  newPlan.sectorAreaHa =
    (selectedSectorRow.length * selectedSectorRow.width) / 10000;
  newPlan.supplierLinesNum = +(
    selectedSectorRow.width / selectedSectorRow.distanceSupplyRows
  ).toFixed(2);
  newPlan.suppliersPerMeter =
    selectedSectorRow.length /
    (selectedSectorRow.distanceSuppliers / 100) /
    selectedSectorRow.length;
  newPlan.suppliersNumPerSector = +(
    newPlan.suppliersPerMeter *
    selectedSectorRow.length *
    newPlan.supplierLinesNum
  ).toFixed(2);
  newPlan.supplierLinesMeters = +(
    newPlan.supplierLinesNum * selectedSectorRow.length
  ).toFixed(2);
  newPlan.sectorFlowRate = +(
    (selectedSectorRow.nominalFlowRate * newPlan.suppliersNumPerSector) /
    1000
  ).toFixed(2);
  newPlan.irrigationRatePerHaM3 = +(
    newPlan.sectorFlowRate / newPlan.sectorAreaHa
  ).toFixed(4);
  newPlan.irrigationRatePerHaMm = +(newPlan.irrigationRatePerHaM3 / 10).toFixed(
    4,
  );
  newPlan.linesPressionTime = +(
    newPlan.supplierLinesMeters /
    lineSpeed /
    60
  ).toFixed(2);
  console.log();
  newPlan.pipesPressionTime = +(
    selectedSectorRow.pipeLength /
    pipeSpeed /
    60
  ).toFixed(2);
  newPlan.totPressionTime = Math.ceil(
    newPlan.linesPressionTime + newPlan.pipesPressionTime,
  );
  newPlan.emptyCleanTime = Number(newPlan.totPressionTime + 5);
  console.log(newPlan);
};

const checkConc = function (fertiPlanData, currRow, rowIndex) {
  const concPlant = currRow.querySelector(".concPlant").value;
  if (concPlant) {
    fertiPlanData[`phaseData${rowIndex}`].concPlant = concPlant;
  }
  if (!concPlant) {
    currRow.addEventListener("input", function (event) {
      if (event.target.classList.contains("concPlant")) {
        fertiPlanData[`phaseData${rowIndex}`].concPlant = event.target.value;
        console.log(fertiPlanData[`phaseData${rowIndex}`]);
        console.log(fertiPlanData);
      }
    });
  }
};

const calcTotPlanUf = function () {
  console.log(newPlan.fertiPlanData);

  const header = headerCrop.slice(2);
  console.log(header);

  const supplyH = header.map((h) => `count${h}`);
  console.log(supplyH);

  //Calc totPlanSupply
  let totPlanSupply = [];
  //let totPlanSupply = new Object();
  supplyH.forEach((supplyH, i) => (totPlanSupply[i] = 0));
  console.log(totPlanSupply);

  newPlan.fertiPlanData.forEach((phaseData) => {
    if (!phaseData.currProdTotSupply) return;
    for (let i = 0; i < phaseData.currProdTotSupply.length; i++) {
      console.log(totPlanSupply[i], phaseData.currProdTotSupply[i]);
      totPlanSupply[i] = (
        Number(totPlanSupply[i]) + Number(phaseData.currProdTotSupply[i])
      ).toFixed(2);
    }
  });

  console.log(totPlanSupply);

  //Calc. deltaFertiSupply
  const deltaFertiSupply = supplyH.map((supplyH, i) => {
    console.log(newPlan);
    return (newPlan.fertiSupplyPerHa[supplyH] - totPlanSupply[i]).toFixed(2);
  });
  console.log(deltaFertiSupply);

  //Upload
  newPlan.totPlanSupply = totPlanSupply;
  newPlan.deltaFertiSupply = deltaFertiSupply;

  //Render tot ferti planned
  renderFertiPlanned(supplyH, totPlanSupply);
  renderFertiVar(supplyH, deltaFertiSupply);

  console.log(newPlan);
};

const calcCurrProdSupply = function () {
  const header = headerCrop.slice(2);
  console.log(header);

  const supplyH = header.map((h) => `count${h}`);

  let currProdSupply, currProdTotSupply;
  newPlan.fertiPlanData.forEach((phaseData) => {
    console.log(phaseData);

    //let productId;
    if (phaseData.intNum) {
      /*
      productId = phaseData.product.slice(0, 5);
      phaseData.productId = productId;
      console.log(productId);*/

      originalFertiProductRows.forEach((prod) => {
        if (prod.productId === phaseData.productId) {
          console.log(prod.productId);
          console.log(prod.countN);
          currProdSupply = supplyH.map((supplyH) => {
            console.log(supplyH, prod[supplyH]);
            return prod[supplyH];
          });
          console.log(currProdSupply);
        }
      });

      currProdTotSupply = currProdSupply.map(
        (supply) => (supply * phaseData.supply * phaseData.intNum) / 100,
      );
      //Upload data in fertiPlanData
      phaseData.currProdSupply = currProdSupply;
      phaseData.currProdTotSupply = currProdTotSupply;

      console.log(currProdTotSupply);
      console.log(newPlan.fertiPlanData);
    }
  });
};

const renderFertiPlanned = function (supplyH, totPlanSupply) {
  const fertiPlannedRow = document.querySelector(".tot-supply-planned-row");

  supplyH.forEach((supplyH, i) => {
    const cellName = `tot-plan-${supplyH}`;
    const currCell = fertiPlannedRow.querySelector(`.${cellName}`);
    console.log(currCell);
    currCell.textContent = totPlanSupply[i];
  });
};

const renderFertiVar = function (supplyH, deltaFertiSupply) {
  const fertiDeltaRow = document.querySelector(".delta-supply-plan-row");

  supplyH.forEach((supplyH, i) => {
    const cellName = `tot-var-${supplyH}`;
    const currCell = fertiDeltaRow.querySelector(`.${cellName}`);
    console.log(currCell);
    currCell.textContent = deltaFertiSupply[i];
  });
};

const calcTotCost = function (minPhaseRow, maxPhaseRow, phase) {
  console.log("calc costs");

  //Find and upload countEuroKg for each phaseData
  //let productId;
  let missingPriceListString = "";
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (
      phaseData.rowId >= minPhaseRow &&
      phaseData.rowId <= maxPhaseRow &&
      phaseData.intNum
    ) {
      //Get priceList

      let validPriceList = "";
      originalFertiProductRows.forEach((prod) => {
        if (prod.productId === phaseData.productId) {
          if (prod.countEurokg) {
            prod.countEurokg.forEach((priceList) => {
              if (priceList[0] === newPlan.companyId) {
                validPriceList = priceList;
              }
            });
          }
        }
      });
      //Check price List
      if (validPriceList !== "") {
        phaseData.validPrice = validPriceList[1];
      }
      if (validPriceList === "") {
        console.log("missing price");
        phaseData.validPrice = 0;
        phaseData.costHa = 0;
        phaseData.costSector = 0;
        newPlan.fertiPlanTotData.forEach((phaseTotData) => {
          if (phaseTotData.phase === phase) {
            phaseTotData.totCostHa = 0;
            phaseTotData.totCostSector = 0;
          }
        });
        if (missingPriceListString !== "") {
          missingPriceListString =
            missingPriceListString + `, ${phaseData.product.slice(37)}`;
        }
        if (missingPriceListString === "") {
          missingPriceListString = `${phaseData.product.slice(37)}`;
        }
      }
    }
  });
  /*
  //Check if fertiPlanData has missingPriceList
  if (missingPriceListString !== "") {
    renderEmptyDataAlertWindow(
      `Prezzo mancante per: ${missingPriceListString}. Se il prezzo non è inserito, non vengono calcolati i costi per il piano. Per ottenere il calcolo dei costi, inserire il prezzo in anagrafica prodotto PRIMA di inserire il piano.`,
      newPlanTableWindow,
      "newPlan"
    );
  }*/

  if (missingPriceListString === "") {
    //Calc single row costs
    newPlan.fertiPlanData.forEach((phaseData) => {
      if (
        phaseData.rowId >= minPhaseRow &&
        phaseData.rowId <= maxPhaseRow &&
        phaseData.intNum
      ) {
        console.log(phaseData.supply);
        const costHa =
          phaseData.supply * phaseData.intNum * phaseData.validPrice;
        const costSector = costHa * newPlan.sectorAreaHa;

        phaseData.costHa = costHa;
        phaseData.costSector = costSector;
      }
      console.log(newPlan.fertiPlanData);
    });

    //Calc and upload tot costs
    let totCostHa = 0;
    let totCostSector = 0;
    newPlan.fertiPlanData.forEach((phaseData) => {
      if (
        phaseData.rowId >= minPhaseRow &&
        phaseData.rowId <= maxPhaseRow &&
        phaseData.intNum
      ) {
        totCostHa = (+totCostHa + Number(phaseData.costHa)).toFixed(2);
        totCostSector = (+totCostSector + Number(phaseData.costSector)).toFixed(
          2,
        );
      }
    });
    console.log(totCostHa, totCostSector);
    newPlan.fertiPlanTotData.forEach((phaseTotData) => {
      if (phaseTotData.phase === phase) {
        phaseTotData.totCostHa = totCostHa;
        phaseTotData.totCostSector = totCostSector;
      }
    }); /*
    //Render tot costs
    const supplyTable = document.querySelector(".supply-table");
    console.log(supplyTable);

    const multipleRow = supplyTable.rows[minPhaseRow];

    multipleRow.querySelector(".calculated-cost-ha").textContent = totCostHa;
    multipleRow.querySelector(".calculated-cost-sector").textContent =
      totCostSector;*/
  }
  /*
  //Render tot costs
  const supplyTable = document.querySelector(".supply-table");
  console.log(supplyTable);

  const multipleRow = supplyTable.rows[minPhaseRow];

  let totCostHa, totCostSector;
  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.phase === phase) {
      totCostHa = phaseTotData.totCostHa;
      totCostSector = phaseTotData.totCostSector;
    }
  });
  if (totCostHa !== 0) {
    multipleRow.querySelector(".calculated-cost-ha").textContent = totCostHa;
    multipleRow.querySelector(".calculated-cost-sector").textContent =
      totCostSector;
  }
  if (totCostHa === 0) {
    multipleRow.querySelector(".calculated-cost-ha").textContent = "-";
    multipleRow.querySelector(".calculated-cost-sector").textContent = "-";
  }*/
};

const renderFertiTotCost = function (minPhaseRow, phase) {
  const supplyTable = document.querySelector(".supply-table");
  console.log(supplyTable);

  const multipleRow = supplyTable.rows[minPhaseRow];

  let totCostHa, totCostSector;
  newPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.phase === phase) {
      totCostHa = phaseTotData.totCostHa;
      totCostSector = phaseTotData.totCostSector;
    }
  });
  if (totCostHa !== 0) {
    multipleRow.querySelector(".calculated-cost-ha").textContent = totCostHa;
    multipleRow.querySelector(".calculated-cost-sector").textContent =
      totCostSector;
  }
  if (totCostHa === 0) {
    multipleRow.querySelector(".calculated-cost-ha").textContent = "-";
    multipleRow.querySelector(".calculated-cost-sector").textContent = "-";
  }
};

export const readFertiPlanTableValues = function () {
  console.log("confirmed fertiPlan");
  //Check input values
  checkFertiPlanValues();
  //Save newPlan in plans

  //Print Report
};

/*
  //Upload in fertiplans ***RIVEDERE

  const existsPlan = originalPlanRows.some(
    (plan) => plan.planId === newPlan.planId
  );
  console.log(existsPlan);
  if (existsPlan) {
    console.log("plan already exists");
  }
  if (!existsPlan) {
    console.log("plan not exists");
    originalPlanRows.push(newPlan);
  }
  console.log(newPlan, originalPlanRows);
*/

const checkFertiPlanValues = function () {
  console.log("check values");
  const periodChecked = checkFinalPeriod();
  let productChecked = false;
  let supplyChecked = false;
  let intNumChecked = false;
  if (periodChecked) {
    productChecked = checkFinalProduct();
  }
  if (productChecked) {
    supplyChecked = checkFinalSupply();
  }
  if (supplyChecked) {
    intNumChecked = checkFinalIntNum();
  }
  if (intNumChecked) {
    checkValidCosts();
  }
};

const checkValidCosts = function () {
  let validCostRows = [];
  let missingPriceListString = "";
  newPlan.fertiPlanData.forEach((phaseData) => {
    console.log(phaseData);
    if (phaseData.costHa) validCostRows.push(phaseData);
    if (!phaseData.costHa) {
      if (!missingPriceListString) {
        console.log(phaseData);
        missingPriceListString = phaseData.product.slice(37);
      }
      if (missingPriceListString) {
        console.log(phaseData);
        if (!missingPriceListString.includes(phaseData.product.slice(37)))
          missingPriceListString = `${missingPriceListString} - ${phaseData.product.slice(
            37,
          )}`;
      }
    }
  });
  if (validCostRows.length === newPlan.fertiPlanData.length) {
    console.log("all rows with valid costs");
  }
  let messageErrorCosts = "";
  if (
    validCostRows.length === newPlan.fertiPlanData.length &&
    missingPriceListStringBase !== ""
  ) {
    console.log("at least one row without cost");

    ((messageErrorCosts = `ATTENZIONE! Prezzo mancante per: ${missingPriceListStringBase}. Se il prezzo non è inserito, non vengono calcolati i costi per il piano. Per ottenere il calcolo dei costi, inserire il prezzo in anagrafica prodotto PRIMA di inserire il piano.`),
      newPlanTableWindow,
      "newPlan");
  }
  if (
    validCostRows.length !== newPlan.fertiPlanData.length &&
    missingPriceListStringBase !== ""
  ) {
    console.log("at least one row without cost");

    ((messageErrorCosts = `ATTENZIONE! Prezzo mancante per: ${missingPriceListStringBase} - ${missingPriceListString}. Se il prezzo non è inserito, non vengono calcolati i costi per il piano. Per ottenere il calcolo dei costi, inserire il prezzo in anagrafica prodotto PRIMA di inserire il piano.`),
      newPlanTableWindow,
      "newPlan");
  }

  reorderFertiPlanData(messageErrorCosts);
};

const checkFinalPeriod = function () {
  console.log("check period");

  if (newPlan.fertiPlanData.length === 0) {
    renderEmptyDataAlertWindow(
      `Attenzione: inserire dati per almeno una Fase Fenologica - Periodo.`,
      newPlanTableWindow,
      "newPlan",
    );
    return false;
  } else {
    let validPeriods = [];
    newPlan.fertiPlanData.forEach((phaseData) => {
      if (phaseData.period) {
        const currRowIndex = phaseData.rowId;
        const [phase, minPhaseRow, maxPhaseRow] =
          getMinMaxPhaseRow(currRowIndex);
        let validPeriod = false;
        newPlan.fertiPlanData.forEach((phaseData) => {
          if (
            phaseData.rowId >= minPhaseRow &&
            phaseData.rowId <= maxPhaseRow &&
            phaseData.product
          ) {
            validPeriod = true;
          }
        });
        console.log(phaseData.period, validPeriod);
        if (!validPeriod) {
          console.log(`${phaseData.period} - ${validPeriod}`);
        }
        validPeriods.push([phaseData.period, validPeriod]);
        console.log(validPeriods);
      }
    });

    const falsePeriods = validPeriods.filter((period) => period[1] === false);
    console.log(falsePeriods);

    let singleFalsePeriods = [];
    falsePeriods.forEach((period) => {
      console.log(singleFalsePeriods, falsePeriods, period);
      console.log(singleFalsePeriods.includes(period));

      if (singleFalsePeriods.includes(period[0])) return;
      if (!singleFalsePeriods.includes(period[0])) {
        singleFalsePeriods.push(period[0]);
        console.log(singleFalsePeriods);
      }
    });
    console.log(singleFalsePeriods);

    if (singleFalsePeriods.length >= 1) {
      let msg;
      if (singleFalsePeriods.length === 1) {
        msg = `Attenzione: la Fase Fenologica ${singleFalsePeriods[0][0]} non ha alcun Prodotto inserito. Inserire almeno un Prodotto o cancellare la Fase Fenologica.`;
      }
      if (singleFalsePeriods.length > 1) {
        const singlePeriodsString = singleFalsePeriods
          .map((period) => {
            console.log(period[0]);
            return period[0];
          })
          .join(" ,");
        msg = `Attenzione: alcune Fasi Fenologiche (${singlePeriodsString}) non hanno alcun Prodotto inserito. Inserire almeno un Prodotto per ciascuna Fase o cancellare la Fase.`;
      }

      renderEmptyDataAlertWindow(msg, newPlanTableWindow, "newPlan");
      return false;
    }
    if (singleFalsePeriods.length === 0) {
      return true;
    }
  }
};

const checkFinalProduct = function () {
  console.log("check product");
  let validProducts = [];
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (phaseData.product) {
      if (phaseData.supply) validProducts.push([phaseData.rowId, true]);
      if (!phaseData.supply) validProducts.push([phaseData.rowId, false]);
    }
  });
  console.log(validProducts);
  const singleFalseProducts = validProducts.filter(
    (product) => product[1] === false,
  );
  console.log(singleFalseProducts);

  if (singleFalseProducts.length >= 1) {
    let msg;
    if (singleFalseProducts.length === 1) {
      msg = `Attenzione: il prodotto di riga ${singleFalseProducts[0][0]} non ha alcuna Dose inserita. Inserire almeno una Dose o cancellare il prodotto.`;
    }
    if (singleFalseProducts.length > 1) {
      const singleProductsString = singleFalseProducts
        .map((period) => {
          console.log(period[0]);
          return period[0];
        })
        .join(" ,");
      msg = `Attenzione: alcuni Prodotti (righe: ${singleProductsString}) non hanno alcuna Dose inserita. Inserire una Dose per ciascun Prodotto o cancellare il Prodotto.`;
    }

    renderEmptyDataAlertWindow(msg, newPlanTableWindow, "newPlan");
    return false;
  }
  if (singleFalseProducts.length === 0) {
    return true;
  }
};

const checkFinalSupply = function () {
  console.log("check supply");

  let validSupplies = [];
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (phaseData.supply) {
      if (phaseData.intNum) validSupplies.push([phaseData.rowId, true]);
      if (!phaseData.intNum) validSupplies.push([phaseData.rowId, false]);
    }
  });
  console.log(validSupplies);
  const singleFalseSupplies = validSupplies.filter(
    (supply) => supply[1] === false,
  );
  console.log(singleFalseSupplies);

  if (singleFalseSupplies.length >= 1) {
    //Check if other rows of the currentPhase have intNum

    singleFalseSupplies.forEach((supply) => {
      if (supply[1] === false) {
        const currRowId = supply[0];
        const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(currRowId);

        let currIntNum = 0;
        newPlan.fertiPlanData.forEach((phaseData) => {
          if (
            phaseData.rowId >= minPhaseRow &&
            phaseData.rowId <= maxPhaseRow &&
            phaseData.intNum
          ) {
            currIntNum = phaseData.intNum;
          }
        });

        if (currIntNum !== 0) {
          newPlan.fertiPlanData.forEach((phaseData) => {
            if (phaseData.rowId === currRowId) {
              phaseData.intNum = intNum;
            }
          });
        }
        if (currIntNum === 0) {
          const msg = `Attenzione: la Fase ${phase} non ha alcun Numero Interventi inserito. Inserire Numero Interventi o cancellare la Fase e tutti i suoi dati. `;
          renderEmptyDataAlertWindow(msg, newPlanTableWindow, "newPlan");
        }
      }
    });

    return false;
  }
  if (singleFalseSupplies.length === 0) {
    return true;
  }
};

const checkFinalIntNum = function () {
  console.log("check intNum");

  let validIntNums = [];
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (phaseData.intNum) {
      if (phaseData.concPlant) validIntNums.push([phaseData.rowId, true]);
      if (!phaseData.concPlant) validIntNums.push([phaseData.rowId, false]);
    }
  });
  console.log(validIntNums);
  const singleFalseIntNums = validIntNums.filter(
    (intNum) => intNum[1] === false,
  );
  console.log(singleFalseIntNums);

  if (singleFalseIntNums.length >= 1) {
    //Check if other rows of the currentPhase have concPlant

    singleFalseIntNums.forEach((intNum) => {
      if (intNum[1] === false) {
        const currRowId = intNum[0];
        const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(currRowId);

        let currConcPlant = 0;
        newPlan.fertiPlanData.forEach((phaseData) => {
          if (
            phaseData.rowId >= minPhaseRow &&
            phaseData.rowId <= maxPhaseRow &&
            phaseData.concPlant
          ) {
            currConcPlant = phaseData.concPlant;
          }
        });

        if (currConcPlant !== 0) {
          newPlan.fertiPlanData.forEach((phaseData) => {
            if (phaseData.rowId === currRowId) {
              phaseData.concPlant = concPlant;
            }
          });
        }
        if (currConcPlant === 0) {
          const msg = `Attenzione: la Fase ${phase} non ha alcuna Concentraz. sulla Pianta inserita. Inserire Concentraz. sulla Pianta o cancellare la Fase e tutti i suoi dati. `;
          renderEmptyDataAlertWindow(msg, newPlanTableWindow, "newPlan");
        }
      }
    });

    return false;
  }
  if (singleFalseIntNums.length === 0) {
    return true;
  }
};

const reorderFertiPlanData = function (messageErrorCosts) {
  console.log("All valid Data-->reorder values");
  console.log(newPlan);

  reorderPhase();
  reorderRow();
  console.log(newPlan);
  uploadFertiPlan(messageErrorCosts);

  //lockEventListenersTable([newPlanNav, menuTag]);

  //console.log(newPlan.planId);
  //controlRenderSavedPlan(newPlan.planId);
};

const reorderPhase = function () {
  console.log("reorder phase");

  //Filter 1st rows without product (not valid rows)
  newPlan.fertiPlanData = newPlan.fertiPlanData.filter(
    (phaseData) => phaseData.product,
  );

  console.log(newPlan);

  //Find phase ordered list
  let phaseList = [];
  newPlan.fertiPlanData.forEach((phaseData) => {
    if (!phaseList.includes(phaseData.phase)) {
      phaseList.push(phaseData.phase);
    }
  });
  phaseList.sort((a, b) => a - b);
  console.log(phaseList);
  console.log(phaseList.length, phaseList[0], phaseList[phaseList.length - 1]);
  if (
    phaseList[0] === 1 &&
    phaseList[phaseList.length - 1] === phaseList.length
  ) {
    console.log("phases are ordered");
  } else {
    console.log("phases are NOT ordered");
    //Fix phase in fertiPlanData
    let currPhase;
    newPlan.fertiPlanData.forEach((phaseData) => {
      currPhase = phaseData.phase;
      console.log(currPhase);
      let currIndex;
      phaseList.forEach((phase, i) => {
        console.log(phase);
        if (currPhase === phase) {
          currIndex = i;
        }
        console.log(currIndex);
      });
      console.log(currIndex);
      phaseData.phase = currIndex + 1;
    });
    //Fix phase in fertiPlanTotData
    let currTotPhase;
    newPlan.fertiPlanTotData.forEach((phaseTotData) => {
      currTotPhase = phaseTotData.phase;
      console.log(currTotPhase);
      let currTotIndex;
      phaseList.forEach((phase, i) => {
        console.log(phase);
        if (currTotPhase === phase) {
          currTotIndex = i;
        }
        console.log(currTotIndex);
      });
      console.log(currTotIndex);
      phaseTotData.phase = currTotIndex + 1;
    });
  }
  console.log(newPlan);
};

const reorderRow = function () {
  console.log("reorder rows");
  //Fix rows based on new phase
  newPlan.fertiPlanData.forEach((phaseData) => {
    console.log("reorder row");
    console.log(phaseData.rowId, phaseData.phase);
    const [phase, minPhaseRow, maxPhaseRow] = getMinMaxPhaseRow(
      phaseData.rowId,
    );
    if (phase === phaseData.phase) {
      console.log("same phase--> same row");
    }
    if (phase !== phaseData.phase) {
      console.log("different phase--> row to fix");
      const deltaMinRow = phaseData.rowId - minPhaseRow;
      console.log(deltaMinRow);

      const newMinPhaseRow =
        phaseData.phase * productsForPhase + 1 - productsForPhase;
      console.log(newMinPhaseRow);
      const newRowId = newMinPhaseRow + deltaMinRow;
      console.log(newRowId);
      phaseData.rowId = newRowId;
    }
  });
  console.log(newPlan);

  //Reorder rows for each phase
  //Find newPhases
  let newPhases = [];
  newPlan.fertiPlanData.forEach((phaseData) => {
    console.log("fix empty rows-find newPhases");
    if (!newPhases.includes(phaseData.phase)) {
      newPhases.push(phaseData.phase);
    }
  });
  console.log(newPhases);

  //Find rows for each phase

  newPhases.forEach((phase) => {
    console.log(phase);
    let validRows = [];
    newPlan.fertiPlanData.forEach((phaseData) => {
      if (phase === phaseData.phase) {
        validRows.push(phaseData.rowId);
      }
    });
    console.log(validRows);
    validRows.sort((a, b) => a - b);
    console.log(validRows);

    if (
      validRows[0] === 1 &&
      validRows[validRows.length] === validRows.length
    ) {
      console.log("all valid rowId");
    } else {
      console.log("Not all valid rowId");

      console.log(phase);
      const newMinPhaseRow = phase * productsForPhase + 1 - productsForPhase;
      console.log(newMinPhaseRow);

      validRows.forEach((row, i) => {
        console.log(row, i);
        newPlan.fertiPlanData.forEach((phaseData) => {
          if (phaseData.phase === phase && phaseData.rowId === row) {
            console.log(phaseData.rowId, i, newMinPhaseRow);
            phaseData.rowId = i + newMinPhaseRow;
          }
        });
      });
      console.log(newPlan);
    }
  });
};

const uploadFertiPlan = async function (messageErrorCosts) {
  console.log("upload newPlan");
  console.log(newPlan);

  let result;
  if (!newPlan.planId) {
    result = await planService.createPlan({
      company_id: newPlan.companyId,
      sector_id: newPlan.sectorId,
      crop_id: newPlan.cropId,
      plan_name: newPlan.planName,
      plan_date: newPlan.date,
      meta: newPlan,
    });

    console.log("newPlan saved", result);
    newPlan.planId = result.id;

    console.log(newPlan);
    console.log(newPlan.planId);
    console.log(result.id);
  }
  if (newPlan.planId) {
    result = await planService.updatePlan(newPlan.planId, {
      company_id: newPlan.companyId,
      sector_id: newPlan.sectorId,
      crop_id: newPlan.cropId,
      plan_name: newPlan.planName,
      plan_date: newPlan.date,
      meta: newPlan,
    });
  }

  controlRenderSavedPlan(newPlan.planId);

  const msg = `Il piano è stato salvato. ${messageErrorCosts}`;
  renderEmptyDataAlertWindow(msg, newPlanTableWindow, "newPlan");
  //lockEventListenersTable([newPlanNav, menuTag]);
};
//--------------CONTROL RENDER SAVED PLAN-------
//-----------------------------------------------
//-----------------------------------------------
const controlRenderSavedPlan = async function (planId) {
  updateNewPlanUI(newPlanMenuBtns, renderPlanBtn, newPlanTableWindow, [
    newPlanNav,
    menuTag,
  ]);

  unlockNav(renderPlanBtn);

  console.log(planId);
  console.log(newPlan.planId);

  await renderPlanRecap(planId, newPlanTableWindow, account);
};

/*const renderPlanRecap = function (planId,window) {

  const markup = `Riepilogo del piano. 
  PlanId: ${planId}.`;

  const markupPdfBtn = `<button class="btn print-pdf-plan_btn">
      <span>Stampa PDF</span>
    </button>`;

  window.insertAdjacentHTML("afterbegin", markup);
  window.insertAdjacentHTML("beforeend", markupPdfBtn);

  const printPdfBtn = document.querySelector(".print-pdf-plan_btn");

  printPdfBtn.addEventListener("click", function () {
    console.log("printPdfBtn clicked");

    printPdf();
  });
};

const printPdf = function () {
  console.log("PRINT PDF");
};
*/

const unlockNav = function (activeBtn) {
  console.log("unlocknav");
  if (activeBtn === dataBtn) return;
  if (activeBtn === supplyProgramBtn) {
    unlockEventListenersTable([newPlanNav]);
    lockEventListenersTable([
      supplyProgramBtn,
      ufPlanBtn,
      fertiPlanBtn,
      renderPlanBtn,
    ]);
  }

  if (activeBtn === ufPlanBtn) {
    unlockEventListenersTable([newPlanNav, supplyProgramBtn]);
    lockEventListenersTable([ufPlanBtn, fertiPlanBtn, renderPlanBtn]);
  }
  if (activeBtn === fertiPlanBtn) {
    unlockEventListenersTable([newPlanNav, supplyProgramBtn, ufPlanBtn]);
    lockEventListenersTable([fertiPlanBtn, renderPlanBtn]);
  }
  if (activeBtn === renderPlanBtn) {
    unlockEventListenersTable([
      newPlanNav,
      supplyProgramBtn,
      ufPlanBtn,
      fertiPlanBtn,
    ]);
    lockEventListenersTable([renderPlanBtn]);
  }
  /*NON CANCELLARE
  if (!newPlan.planId) {
    return;
  }
  console.log(newPlan.supplyProgram);
  if (newPlan.planId && !newPlan.supplyProgram) {
    console.log("unlock data btn");
    unlockEventListenersTable([newPlanNav]);
    lockEventListenersTable([
      supplyProgramBtn,
      ufPlanBtn,
      fertiPlanBtn,
      renderPlanBtn,
    ]);
  }
  console.log(newPlan.ufBaseSupply);
  if (newPlan.planId && newPlan.supplyProgram && !newPlan.ufBaseSupply) {
    console.log("unlock supplyProgramBtn");
    unlockEventListenersTable([newPlanNav, supplyProgramBtn]);

    console.log(newPlanNav);
  }
  if (
    newPlan.planId &&
    newPlan.supplyProgram &&
    newPlan.ufBaseSupply &&
    newPlan.fertiPlanData.length === 0
  ) {
    console.log("unlock ufPlanBtn");
    unlockEventListenersTable([newPlanNav, ufPlanBtn]);
  }
  if (
    newPlan.planId &&
    newPlan.supplyProgram &&
    newPlan.ufBaseSupply &&
    newPlan.fertiPlanData.length !== 0
  ) {
    console.log("unlock fertiPlanBtn");
    unlockEventListenersTable([newPlanNav, fertiPlanBtn]);
  }*/
};

const checkNavBtns = function (currActiveBtn) {
  console.log("checknavbtns");
  console.log(newPlanNav);
  newPlanNav.addEventListener("click", function (e) {
    e.preventDefault();
    console.log("newPlanNav clicked");
    console.log(e.target);
    const btnClicked = e.target.closest(".btn");
    console.log(btnClicked);

    if (btnClicked === dataBtn) {
      console.log("dataBtn clicked");
      controlDataSection();
    }
    if (btnClicked === supplyProgramBtn) {
      console.log("supplyProgramBtn clicked");
      controlSupplyProgram();
    }
    if (btnClicked === ufPlanBtn) {
      console.log("ufPlanBtn clicked");
      controlBasicProgram();
    }
    if (btnClicked === fertiPlanBtn) {
      console.log("fertiPlanBtn clicked");
      controlFertiProgram();
    }
    if (btnClicked === renderPlanBtn) {
      console.log("renderPlanBtn clicked");
      controlRenderSavedPlan(newPlan.planId);
    }
  });
};
